webpackJsonp([1],{

/***/ "+5rB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("kt2W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7b628a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("iFVq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7b628a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+AVc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_good_table__ = __webpack_require__("rKEe");






// Bootstraps VueGoodTable component
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_good_table__["a" /* default */]);

// bootstrap-vue
// Bootstrap components and directives
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);

// vue-meta
// supports `meta` object returned with `module.defaults`
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_meta___default.a);

// vuex
// State management library
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/***/ }),

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("/Put");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("/1Lr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+UDm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collection']
});

/***/ }),

/***/ "/1Lr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/EPi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrayInput_vue__ = __webpack_require__("oLr1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_933b6406_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrayInput_vue__ = __webpack_require__("u5nZ");
function injectStyle (ssrContext) {
  __webpack_require__("VGg9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-933b6406"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrayInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_933b6406_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrayInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Put":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__("fnDg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),

/***/ "/qDV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Record Module State
var state = {
  collection: [{
    _id: 'rec_32976293799615',
    schema_id: 'schema_29321443037762',
    attributes: {
      name: 'Al Schwaa',
      location: 'Troy, NY',
      phone: '+1 (518) 212-8923',
      email: 'al@schwaa.com',
      address_id: 'AD_51111498775682'
    }
  }, {
    _id: 'rec_83122409943633',
    schema_id: 'schema_29321443037762',
    attributes: {
      name: 'John Doe',
      location: 'NY, NY',
      phone: '+1 (518) 219-2219',
      email: 'john@doe.com'
    }
  }, {
    _id: 'rec_50813637509925',
    schema_id: 'schema_22881179555990',
    attributes: {
      contact_id: 'rec_32976293799615',
      amount: '500.00',
      payment_received: true,
      date: '2018-01-10',
      invoice_id: 'IN_00001'
    }
  }, {
    _id: 'rec_20022846283213',
    schema_id: 'schema_22881179555990',
    attributes: {
      contact_id: 'rec_32976293799615',
      amount: '200.00',
      payment_received: null,
      date: '2018-01-25',
      invoice_id: 'IN_00002'
    }
  }, {
    _id: 'rec_56277813766977',
    schema_id: 'schema_22881179555990',
    attributes: {
      contact_id: 'rec_83122409943633',
      amount: '25.25',
      payment_received: null,
      date: '2018-01-17',
      invoice_id: 'IN_00003'
    }
  }, {
    _id: 'rec_10283797663298',
    schema_id: 'schema_85414304137721',
    attributes: {
      job_id: 'JB_00001',
      contact_id: 'rec_32976293799615',
      invoice_id: 'rec_50813637509925',
      status: 'Completed'
    }
  }, {
    _id: 'rec_33864531983515',
    schema_id: 'schema_85414304137721',
    attributes: {
      job_id: 'JB_00002',
      contact_id: 'rec_83122409943633',
      invoice_id: 'rec_56277813766977',
      status: 'In-Progress'
    }
  }, {
    schema_id: 'schema_14808974981067',
    _id: 'AD_51111498775682',
    attributes: {
      street_address: '123 South St',
      street_address_two: 'Suite 320',
      city: 'Troy',
      state: 'New York',
      zip_code: '12180'
    }
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ "/wTD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecordTable_vue__ = __webpack_require__("B1Xx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_810ca2d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecordTable_vue__ = __webpack_require__("h0gN");
function injectStyle (ssrContext) {
  __webpack_require__("kTc3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecordTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_810ca2d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecordTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1WY9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1nk7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collection'],
  methods: {
    destroySchema: function destroySchema(schema) {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('schema/destroy', { schema: schema });
    }
  }
});

/***/ }),

/***/ "2OCT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-lg navbar-dark bg-dark"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav mr-auto"},[_vm._l((_vm.navSchemas),function(s){return _c('li',{key:s._id,staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":'#/schemas/' + s._id}},[_vm._v(_vm._s(s.label_plural))])])}),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/schemas/new"}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"fa fa-fw fa-plus",attrs:{"title":"New Schema"}})])])],2),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto"},[_c('b-nav-item-dropdown',{attrs:{"text":"Admin","right":""}},[_c('b-dropdown-item',{attrs:{"href":"#/schemas"}},[_vm._v("Schemas")])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand",attrs:{"href":"#/"}},[_c('strong',[_vm._v("Hot")]),_vm._v("Sheets\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2hMI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var API_URL = 'http://api.dev/v1/';

function apiUrl(path) {
  return API_URL + path;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  api: {
    auth_url: apiUrl('auth')
  }
});

/***/ }),

/***/ "2kl+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("QR+I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32151f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("cnQG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32151f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2klK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("z2OK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1472bb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("C148");
function injectStyle (ssrContext) {
  __webpack_require__("KAVM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1472bb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2uFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__("+AVc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("2hMI");
// Application-wide configurations



/* unused harmony default export */ var _unused_webpack_default_export = ({
  api: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */]
});

/***/ }),

/***/ "2z2G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("7zYZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38ddfa75_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("CMUZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38ddfa75_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Fh7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory__ = __webpack_require__("SDS1");


// // // //

// actions
// functions that causes side effects and can involve asynchronous operations.
var actions = {
  fetchCollection: function fetchCollection(_ref) {
    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_0__factory__["a" /* default */].fetchCollection({ commit: commit });
  },

  fetchModel: function fetchModel(_ref2, id) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0__factory__["a" /* default */].fetchModel({ commit: commit }, id);
  },

  create: function create(_ref3, attributes) {
    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_0__factory__["a" /* default */].create({ commit: commit }, attributes);
  },

  update: function update(_ref4, attributes) {
    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_0__factory__["a" /* default */].update({ commit: commit }, attributes);
  },

  destroy: function destroy(_ref5, id) {
    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_0__factory__["a" /* default */].destroy({ commit: commit }, id);
  }

  // // // //

};/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ "3P4K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


// Schema Module Getters
var getters = {
  new: function _new(state) {
    var schema = {
      _id: null,
      label: '',
      label_plural: '',
      identifier: '',
      identifier_plural: '',
      attributes: [],
      display: {
        icon: 'fa-square-o',
        navbar_link: true
      }
    };
    return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
  },
  collection: function collection(state) {
    return state.collection;
  },
  selectedSchema: function selectedSchema(state) {
    return state.selectedSchema;
  },
  selectedAttribute: function selectedAttribute(state) {
    return state.selectedAttribute;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "3URG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__ = __webpack_require__("oQdh");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'auth_login',
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Auth - Login'
  }
});

/***/ }),

/***/ "3x7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainHomeRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_main_home__ = __webpack_require__("FtZF");
// Main Containers


var MainHomeRoute = {
  path: '/',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_0__containers_main_home__["a" /* default */]
};

/***/ }),

/***/ "48Rt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('a',{attrs:{"href":"#/applications"}},[_vm._v("Back")]),_vm._v(" "),_c('h2',[_vm._v("Application Show - "+_vm._s(_vm.model.name))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('a',{staticClass:"btn btn-secondary",attrs:{"href":'#/applications/' + _vm.model._id + '/edit'}},[_vm._v("\n    Edit Application\n  ")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.confirm-modal",modifiers:{"confirm-modal":true}}],attrs:{"variant":"danger"}},[_vm._v("Destroy")]),_vm._v(" "),_c('b-modal',{attrs:{"id":"confirm-modal","title":"Destroy Application?"},on:{"ok":_vm.onConfirm}},[_c('p',{staticClass:"my-4"},[_vm._v("Are you sure you want to destroy this Application?")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4QAh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("qZEt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_342d6773_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("xcLB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_342d6773_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4n4Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView',{attrs:{"schema":_vm.data.schema,"record":_vm.data.record}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4pT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ApplicationListRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ApplicationNewRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ApplicationShowRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationEditRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_application_list__ = __webpack_require__("H5cU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_application_new__ = __webpack_require__("fmIs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_application_show__ = __webpack_require__("CVSZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_application_edit__ = __webpack_require__("Kx1p");
// Application Containers





var ApplicationListRoute = {
  path: '/applications',
  component: __WEBPACK_IMPORTED_MODULE_0__containers_application_list__["a" /* default */]
};

var ApplicationNewRoute = {
  path: '/applications/new',
  component: __WEBPACK_IMPORTED_MODULE_1__containers_application_new__["a" /* default */]
};

var ApplicationShowRoute = {
  path: '/applications/:id',
  component: __WEBPACK_IMPORTED_MODULE_2__containers_application_show__["a" /* default */],
  props: true
};

var ApplicationEditRoute = {
  path: '/applications/:id/edit',
  component: __WEBPACK_IMPORTED_MODULE_3__containers_application_edit__["a" /* default */],
  props: true

  // Add to src/routers/index.js:
  // import { ApplicationListRoute, ApplicationShowRoute, ApplicationNewRoute, ApplicationEditRoute } from './application'
  // ApplicationListRoute,
  // ApplicationNewRoute,
  // ApplicationShowRoute,
  // ApplicationEditRoute

};

/***/ }),

/***/ "50KH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notificationChild__ = __webpack_require__("mxBa");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    collection: function collection() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['notification/collection'];
    }
  },
  components: {
    NotificationChild: __WEBPACK_IMPORTED_MODULE_1__notificationChild__["a" /* default */]
  }
});

/***/ }),

/***/ "55l9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  methods: {
    formSubmit: function formSubmit() {
      // TODO - validations
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('application/persist', { app: this.model });
    }
  },
  computed: {
    model: function model() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['application/current'];
    }
  }

});

/***/ }),

/***/ "5F5L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__ = __webpack_require__("2klK");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main_home',
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Main - Home'
  }
});

/***/ }),

/***/ "5tXk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("l5BX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d32e962_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("TF4F");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d32e962_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "62hB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("Schemas")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.collection),function(schema){return _c('div',{key:schema._id,staticClass:"col-lg-12 mt-2"},[_c('div',{staticClass:"card card-body bg-dark border-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8"},[_c('a',{attrs:{"href":'#/schemas/' + schema._id}},[_vm._v(_vm._s(schema.label_plural))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 text-right"},[_c('a',{staticClass:"btn btn-sm btn-outline-light",attrs:{"href":'#/schemas/' + schema._id}},[_c('i',{staticClass:"fa fa-list-alt mr-1"}),_vm._v("\n              Records\n            ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-outline-warning",attrs:{"href":'#/schemas/' + schema._id + '/edit'}},[_c('i',{staticClass:"fa fa-pencil mr-1"}),_vm._v("\n              Edit\n            ")]),_vm._v(" "),_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('modal_' + schema._id),expression:"'modal_' + schema._id"}],staticClass:"btn btn-sm btn-outline-danger"},[_c('i',{staticClass:"fa mr-1 fa-trash"}),_vm._v("\n              Destroy\n            ")]),_vm._v(" "),_c('b-modal',{attrs:{"id":'modal_' + schema._id,"title":'Destroy ' + schema.label + '?',"header-bg-variant":"dark","header-text-variant":"light","body-bg-variant":"dark","body-text-variant":"light","footer-bg-variant":"danger","footer-text-variant":"light","ok-variant":"danger","ok-title":"DESTROY","cancel-title":"Cancel","cancel-variant":"dark"},on:{"ok":function($event){_vm.destroySchema(schema)}}},[_c('p',{staticClass:"text-left"},[_vm._v("Are you sure you want to destroy the "+_vm._s(schema.label)+" schema?")])])],1)])])])})),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-lg-12"},[_c('a',{staticClass:"btn btn-block btn-outline-success",attrs:{"href":"#/schemas/new"}},[_c('i',{staticClass:"fa fa-fw fa-plus mr-2"}),_vm._v("\n        New Schema\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6EED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("3Fh7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__("yaHL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__("sRpY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("UY6v");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),

/***/ "6QA3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6QGx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12 text-center"},[_c('div',{staticClass:"alert alert-dismissible fade show",class:'alert-' + _vm.item.context,attrs:{"role":"alert"}},[(_vm.item.dismissible)?_c('button',{staticClass:"close",attrs:{"data-dismiss":"alert","aria-label":"Close"},on:{"click":function($event){_vm.dismiss(_vm.item.id)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Close")])]):_vm._e(),_vm._v(" "),(_vm.item.strong)?_c('strong',[_vm._v(_vm._s(_vm.item.strong))]):_vm._e(),_vm._v("\n\n    "+_vm._s(_vm.item.message)+"\n\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6QP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SchemaListRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SchemaNewRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SchemaShowRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SchemaEditRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RecordNewRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RecordShowRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RecordEditRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_schema_list__ = __webpack_require__("GZT8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_schema_new__ = __webpack_require__("tjOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_schema_show__ = __webpack_require__("kzQ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_schema_edit__ = __webpack_require__("jE1R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_record_new__ = __webpack_require__("O2IH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_record_edit__ = __webpack_require__("5tXk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_record_show__ = __webpack_require__("kSTY");
// Workflow Containers








var SchemaListRoute = {
  path: '/schemas',
  component: __WEBPACK_IMPORTED_MODULE_0__containers_schema_list__["a" /* default */],
  props: true
};

var SchemaNewRoute = {
  path: '/schemas/new',
  component: __WEBPACK_IMPORTED_MODULE_1__containers_schema_new__["a" /* default */]
};

var SchemaShowRoute = {
  path: '/schemas/:id',
  component: __WEBPACK_IMPORTED_MODULE_2__containers_schema_show__["a" /* default */],
  props: true
};

var SchemaEditRoute = {
  path: '/schemas/:id/edit',
  component: __WEBPACK_IMPORTED_MODULE_3__containers_schema_edit__["a" /* default */],
  props: true
};

var RecordNewRoute = {
  path: '/schemas/:id/records/new',
  component: __WEBPACK_IMPORTED_MODULE_4__containers_record_new__["a" /* default */],
  props: true
};

var RecordShowRoute = {
  path: '/schemas/:id/records/:record_id',
  component: __WEBPACK_IMPORTED_MODULE_6__containers_record_show__["a" /* default */],
  props: true
};

var RecordEditRoute = {
  path: '/schemas/:id/records/:record_id/edit',
  component: __WEBPACK_IMPORTED_MODULE_5__containers_record_edit__["a" /* default */],
  props: true
};

/***/ }),

/***/ "6yg/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h2',[_vm._v("Application List")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(0),_vm._v(" "),(!_vm.collection[0])?_c('p',{staticClass:"lead"},[_vm._v("\n        EMPTY\n      ")]):_vm._e(),_vm._v(" "),_c('ListView',{attrs:{"collection":_vm.collection}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group mt-2 mb-4 text-center"},[_c('a',{staticClass:"list-group-item",attrs:{"href":"#/applications/new"}},[_vm._v("NEW")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7zYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormInput__ = __webpack_require__("O9rZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormSubmit__ = __webpack_require__("ix0u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




window.store = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: 'alex@foo.bar',
      password: 'abc123abc123',
      remember: false,
      loading: false,
      error: false
    };
  },


  components: {
    FormInput: __WEBPACK_IMPORTED_MODULE_0__components_FormInput__["a" /* default */],
    FormSubmit: __WEBPACK_IMPORTED_MODULE_1__components_FormSubmit__["a" /* default */]
  },

  methods: {
    isValid: function isValid() {
      return !(this.email === '' || this.password === '');
    },
    register: function register() {
      if (!this.isValid()) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/register', { username: this.email, password: this.password });
    }
  }
});

/***/ }),

/***/ "8+Rs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routers__ = __webpack_require__("Q3uA");


// import { TEXT_WORKFLOW_STEP, MACRO_WORKFLOW_STEP, DELAY_WORKFLOW_STEP, KEY_WORKFLOW_STEP, KEY_DN_POSITION, KEY_UP_POSITION, KEY_PR_POSITION } from './constants'

// // // //

// Application Module mutations
var mutations = {
  persist: function persist(state, _ref) {
    var app = _ref.app;

    if (app._id) {
      state.collection = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(state.collection, function (s) {
        if (s._id === app._id) {
          return app;
        } else {
          return s;
        }
      });
    } else {
      app._id = 'app_' + Math.floor(Math.random() * 100000000000000 + 1);
      state.collection.push(app);
    }

    // TODO - redirect to app show / table page
    return __WEBPACK_IMPORTED_MODULE_1__routers__["a" /* default */].go(-1);
  },
  destroy: function destroy(state, _ref2) {
    var app = _ref2.app;

    state.collection = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(state.collection, function (s) {
      return s._id !== app._id;
    });
  },
  fetching: function fetching(state, isFetching) {
    state.fetching = isFetching;
  },
  sync: function sync(state, collection) {
    state.collection = collection;
  },
  current: function current(state, _ref3) {
    var app_id = _ref3.app_id;

    var app = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(state.collection, { _id: app_id });
    state.current = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(app);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "8EGV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9YOS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Project Module State
var state = {
  fetching: false,
  token: null,
  user: {},
  googleAuthenticated: false,
  googleUser: {}
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ "9haB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routers__ = __webpack_require__("Q3uA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AttributeForm__ = __webpack_require__("Reyk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormInput__ = __webpack_require__("O9rZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['schema'],
  components: {
    AttributeForm: __WEBPACK_IMPORTED_MODULE_2__AttributeForm__["a" /* default */],
    FormInput: __WEBPACK_IMPORTED_MODULE_3__components_FormInput__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('schema/clearSelectedAttribute');
  },

  methods: {
    onSubmit: function onSubmit() {
      if (this.schema.label && this.schema.identifier && this.schema.label_plural) {
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('schema/persist', { schema: this.schema });
        __WEBPACK_IMPORTED_MODULE_1__routers__["a" /* default */].go(-1);
      }
    },
    clearSelected: function clearSelected() {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('schema/clearSelectedAttribute');
    }
  },
  computed: {
    selectedAttr: function selectedAttr() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['schema/selectedAttribute'];
    }
  }
});

/***/ }),

/***/ "9ix5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("1nk7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_777d7978_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("62hB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_777d7978_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B1Xx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['schema', 'records', 'ignoreAttribute', 'disableControls'],
  methods: {
    onConfirmDestroy: function onConfirmDestroy(record) {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('record/destroy', { record: record });
    },
    getLinkedSchemaHref: function getLinkedSchemaHref(attr, record_id) {
      var allRecords = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['record/collection'];
      var allSchemas = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
      var record = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allRecords, { _id: record_id });
      if (!record) return;
      var schema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allSchemas, { _id: record.schema_id });
      return '#/schemas/' + schema._id + '/records/' + record._id;
    },
    getLinkedSchemaLabel: function getLinkedSchemaLabel(attr, record_id) {
      var allRecords = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['record/collection'];
      var record = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allRecords, { _id: record_id });
      if (!record) return;

      var identifier = attr.datatypeOptions.schema_attribute_identifier;
      return record.attributes[identifier];
    }
  },
  computed: {
    table: function table() {
      var table = [];

      // Builds Headers
      table.columns = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.schema.attributes, function (attr) {
        return {
          label: attr.label,
          field: attr.identifier,
          type: attr.datatype.toLowerCase()
        };
      });

      // Builds Rows
      table.rows = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.records, function (r) {
        return r.attributes;
      });

      return table;
    }
  }
});

/***/ }),

/***/ "B4Cs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-striped table-hover"},[_c('thead',[_c('th',[_vm._v("\n      Name\n      "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],staticClass:"fa fa-fw fa-question-circle-o",attrs:{"title":"Application Name"}})]),_vm._v(" "),_c('th',[_vm._v("\n      Google Sheets ID\n      "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],staticClass:"fa fa-fw fa-question-circle-o",attrs:{"title":"ID of the Google Sheet used to build the application."}})]),_vm._v(" "),_c('th')]),_vm._v(" "),_c('tbody',_vm._l((_vm.collection),function(m){return _c('tr',{key:m._id},[_c('td',[_c('a',{attrs:{"href":'#/applications/' + m._id}},[_vm._v("\n          "+_vm._s(m.name)+"\n        ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(m.google_sheets_id))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-sm btn-outline-warning",attrs:{"href":'#/applications/' + m._id + '/edit'}},[_c('i',{staticClass:"fa fa-fw fa-pencil"})])])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BYfJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Schema Module Getters
var getters = {
  collection: function collection(state) {
    return state.collection;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "Bls+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_vue__ = __webpack_require__("VeKM");
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_2__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Schema - New Record' // title is now "HotSheets - Schema - New Record"
  },
  props: ['id'],
  computed: {
    data: function data() {
      var schemas = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
      var schema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(schemas, { _id: this.id });

      // TODO - abstract into Vuex store
      var record = {
        _id: null,
        schema_id: schema._id,
        attributes: {}
      };

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(schema.attributes, function (attr) {
        record.attributes[attr.identifier] = null; // Adds attribute to record object
        if (attr.datatypeOptions.default) {
          record.attributes[attr.identifier] = attr.datatypeOptions.default;
        }
      });

      return { schema: schema, record: record };
    }
  }
});

/***/ }),

/***/ "C148":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row h-100 align-items-center"},[_c('div',{staticClass:"col-lg-12"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row py-2 justify-content-center"},[_c('div',{staticClass:"col-lg-6"},[_c('b-carousel',{attrs:{"id":"carousel1","interval":4000,"img-width":"1024","img-height":"480"}},[_c('b-carousel-slide',{attrs:{"img-blank":true}},[_c('div',{staticClass:"card card-body bg-dark text-light border-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h2',{staticClass:"text-left"},[_vm._v("Work Order")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('table',{staticClass:"table table-striped table-hover"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v("Job ID")])]),_vm._v(" "),_c('td',[_vm._v("wo_002817")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v("...")])]),_vm._v(" "),_c('td',[_vm._v("...")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v("...")])]),_vm._v(" "),_c('td',[_vm._v("...")])])])])])])])]),_vm._v(" "),_c('b-carousel-slide',{attrs:{"img-blank":true}},[_c('div',{staticClass:"card card-body bg-dark text-light border-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h2',{staticClass:"text-left"},[_vm._v("Contact")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('table',{staticClass:"table table-striped table-hover"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v("Name")])]),_vm._v(" "),_c('td',[_vm._v("John Doe")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v("...")])]),_vm._v(" "),_c('td',[_vm._v("...")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v("...")])]),_vm._v(" "),_c('td',[_vm._v("...")])])])])])])])]),_vm._v(" "),_c('b-carousel-slide',{attrs:{"img-blank":true}},[_c('div',{staticClass:"card card-body bg-dark text-light border-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h2',{staticClass:"text-left"},[_vm._v("Invoice")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('table',{staticClass:"table table-striped table-hover"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v("Amount")])]),_vm._v(" "),_c('td',[_vm._v("$4800.00")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v("...")])]),_vm._v(" "),_c('td',[_vm._v("...")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v("...")])]),_vm._v(" "),_c('td',[_vm._v("...")])])])])])])])])],1)],1)]),_vm._v(" "),_vm._m(3)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row my-2"},[_c('div',{staticClass:"col-lg-12 text-center"},[_c('p',{staticClass:"welcome-text"},[_vm._v("WELCOME")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row my-2"},[_c('div',{staticClass:"col-lg-12 text-center"},[_c('p',{staticClass:"lead"},[_c('a',{attrs:{"href":"https://github.com/aeksco","target":"_blank"}},[_vm._v(" HotSheets")]),_vm._v(" is an open-source tool for building user interfaces to collect and view tabular data.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row py-2"},[_c('div',{staticClass:"col-lg-12 text-center"},[_c('p',{staticClass:"lead"},[_vm._v("Define your schema and its attributes - HotSheets does the rest.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-4"},[_c('a',{staticClass:"btn btn-light btn-block btn-lg",attrs:{"href":"#/schemas"}},[_c('i',{staticClass:"fa fa-fw fa-list-alt mr-2"}),_vm._v("Let's get started.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C2Ba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routers__ = __webpack_require__("Q3uA");


// import { TEXT_WORKFLOW_STEP, MACRO_WORKFLOW_STEP, DELAY_WORKFLOW_STEP, KEY_WORKFLOW_STEP, KEY_DN_POSITION, KEY_UP_POSITION, KEY_PR_POSITION } from './constants'

// // // //

// Record Module mutations
var mutations = {
  sync: function sync(state, collection) {
    state.collection = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(collection, function (s) {
      return s.order;
    });
  },
  persist: function persist(state, _ref) {
    var schema = _ref.schema,
        record = _ref.record,
        redirect = _ref.redirect;

    if (record._id) {
      state.collection = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(state.collection, function (s) {
        if (s._id === record._id) {
          return record;
        } else {
          return s;
        }
      });
    } else {
      record._id = schema.unqiue_id_prefix + Math.floor(Math.random() * 100000000000000 + 1);
      state.collection.push(record);
    }

    // Redirects 'back' if necessary
    if (redirect) {
      __WEBPACK_IMPORTED_MODULE_1__routers__["a" /* default */].go(-1);
    }
  },
  destroy: function destroy(state, _ref2) {
    var record = _ref2.record;

    state.collection = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(state.collection, function (s) {
      return s._id !== record._id;
    });
  }
};

// // // //

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "C52G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView',{attrs:{"model":_vm.model}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CMUZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container h-100"},[_c('div',{staticClass:"row d-flex justify-content-center"},[_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card card-body bg-dark text-light border-light"},[_c('h4',{staticClass:"card-title"},[_vm._v("Register")]),_vm._v(" "),(_vm.$route.query.redirect)?_c('p',{staticClass:"card-text"},[_vm._v("You need to login first.")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.register($event)}}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"placeholder":"E-mail","type":"text"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"placeholder":"Password","type":"password","value":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('FormSubmit'),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"error"},[_vm._v("Bad registration information")]):_vm._e()],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CVSZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("e4Bl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96040d4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("bJBA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96040d4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ct8H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("tBuJ");




/* harmony default export */ __webpack_exports__["a"] = ({
  // register
  register: function register(attributes) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      return fetch(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* REGISTER_ROUTE */], {
        method: 'post',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(attributes),
        headers: new Headers({ 'Content-Type': 'application/json' })
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return resolve(json);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },


  // authenticate
  authenticate: function authenticate(attributes) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      return fetch(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* AUTHENTICATE_ROUTE */], {
        method: 'post',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(attributes),
        headers: new Headers({ 'Content-Type': 'application/json' })
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return resolve(json);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },


  // getSession
  getSession: function getSession(token) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      return fetch(__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* SESSION_ROUTE */], {
        headers: new Headers({ 'Authorization': 'JWT ' + token })
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return resolve(json);
      }).catch(function (err) {
        return reject(err);
      });
    });
  }
});

/***/ }),

/***/ "DIqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("P/SL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad2be9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("ERkL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad2be9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EMWT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory__ = __webpack_require__("PD9V");


// // // //

// actions
// functions that causes side effects and can involve asynchronous operations.
var actions = {
  fetchSheet: function fetchSheet(_ref, _ref2) {
    var commit = _ref.commit;
    var spreadsheetId = _ref2.spreadsheetId;

    window.gapi.client.sheets.spreadsheets.get({
      spreadsheetId: spreadsheetId // '17SHgu0kODoZS-zQY3YvtKIU5gYo4xtCJYUY7g3QAdyE'
    }).then(function (response) {
      console.log('FETCHED SHEET');
      console.log(response);
      if (response.result) {
        commit('currentSheet', response.result);
      }
    }, function (response) {
      console.error('Unable to fetch sheet list');
    });
  },

  create: function create(_ref3, attributes) {
    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_0__factory__["a" /* default */].create({ commit: commit }, attributes);
  },

  update: function update(_ref4, attributes) {
    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_0__factory__["a" /* default */].update({ commit: commit }, attributes);
  },

  loadSheetAPI: function loadSheetAPI(_ref5) {
    var commit = _ref5.commit;

    console.info('Loading sheet api...');
    window.gapi.client.load('https://sheets.googleapis.com/$discovery/rest?version=v4') // TODO - constantize URI
    .then(function (resp) {
      console.log('LOADED CLIENT');
      console.log(resp);
      commit('api_loaded', true);
      // console.error('Unable to load sheet api')
    });
  },

  fetchSheetValues: function fetchSheetValues(_ref6, _ref7) {
    var commit = _ref6.commit;
    var spreadsheetId = _ref7.spreadsheetId,
        page = _ref7.page,
        range = _ref7.range;

    // page = 'HOTSHEETS_01'
    window.gapi.client.sheets.spreadsheets.values.get({
      spreadsheetId: spreadsheetId,
      range: page + range // '!A2:C' // TODO - parameterize the range selection here
    }).then(function (resp) {
      console.log(resp);
    });
  }

  // // // //

};/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ "ERkL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card card-body bg-dark color-light border-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8"},[_c('h2',[(_vm.schema.display.icon)?_c('i',{class:'fa fa-fw ' + _vm.schema.display.icon}):_vm._e(),_vm._v("\n              "+_vm._s(_vm.schema.label)+" Detail\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 text-right"},[_c('a',{staticClass:"btn btn-outline-warning btn-sm",attrs:{"href":'#/schemas/' + _vm.schema._id + '/records/' + _vm.record._id + '/edit'}},[_c('i',{staticClass:"fa fa-fw fa-pencil mr-1"}),_vm._v("\n              Edit\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('table',{staticClass:"table table-striped table-hover"},[_c('tbody',_vm._l((_vm.schema.attributes),function(attr){return (attr.datatype !== 'HAS_MANY' && attr.datatype !== 'HAS_ONE')?_c('tr',{key:attr._id},[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v("\n                      "+_vm._s(attr.label)+"\n                    ")])]),_vm._v(" "),_c('td',[(attr.datatype === 'BELONGS_TO')?_c('a',{attrs:{"href":_vm.getLinkedSchemaHref(attr, _vm.record.attributes[attr.identifier])}},[_vm._v("\n                      "+_vm._s(_vm.getLinkedSchemaLabel(attr, _vm.record.attributes[attr.identifier]))+"\n                    ")]):(attr.datatype === 'BOOL')?_c('span',[(_vm.record.attributes[attr.identifier])?_c('i',{staticClass:"fa fa-fw fa-check-square-o"}):_vm._e(),_vm._v(" "),(!_vm.record.attributes[attr.identifier])?_c('i',{staticClass:"fa fa-fw fa-square-o"}):_vm._e()]):_c('span',[_vm._v(_vm._s(_vm.record.attributes[attr.identifier]))])])]):_vm._e()}))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.schema.attributes),function(attr){return (attr.datatype === 'HAS_MANY' || attr.datatype === 'HAS_ONE')?_c('div',{key:attr._id,class:'mt-4 col-lg-' + attr.col_span},[(attr.datatype === 'HAS_MANY')?_c('div',{staticClass:"card card-body bg-dark color-light border-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8"},[_c('p',{staticClass:"lead mb"},[(_vm.relatedSchema(attr).display.icon)?_c('i',{class:'fa fa-fw ' + _vm.relatedSchema(attr).display.icon}):_vm._e(),_vm._v("\n              "+_vm._s(_vm.relatedSchemaName(attr))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 text-right"},[_c('a',{staticClass:"btn btn-outline-success btn-sm",attrs:{"href":'#/schemas/' + _vm.relatedSchema(attr)._id + '/records/new'}},[_c('i',{staticClass:"fa fa-fw fa-plus mr-1"}),_vm._v("\n              Add\n            ")])])]),_vm._v(" "),_c('RecordTable',{attrs:{"schema":_vm.relatedSchema(attr),"records":_vm.getRelatedRecords(attr),"ignoreAttribute":_vm.schema.identifier + '_id'}})],1):_vm._e(),_vm._v(" "),(attr.datatype === 'HAS_ONE')?_c('div',{staticClass:"card card-body bg-dark color-light border-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8"},[_c('p',{staticClass:"lead mb"},[(_vm.relatedSchema(attr).display.icon)?_c('i',{class:'fa fa-fw ' + _vm.relatedSchema(attr).display.icon}):_vm._e(),_vm._v("\n              "+_vm._s(_vm.relatedSchemaName(attr))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 text-right"},[(_vm.getRelatedRecords(attr) && _vm.editingHasOne !== attr.identifier)?_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('modal_' + attr._id),expression:"'modal_' + attr._id"}],staticClass:"btn btn-outline-danger btn-sm"},[_c('i',{staticClass:"fa fa-fw fa-trash mr-1"}),_vm._v("\n              Destroy\n            ")]):_vm._e(),_vm._v(" "),(_vm.getRelatedRecords(attr) && _vm.editingHasOne !== attr.identifier)?_c('button',{staticClass:"btn btn-outline-warning btn-sm",on:{"click":function($event){_vm.editingHasOne = attr.identifier}}},[_c('i',{staticClass:"fa fa-fw fa-pencil mr-1"}),_vm._v("\n              Edit\n            ")]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"id":'modal_' + attr._id,"title":'Destroy ' + attr.label + '?',"header-bg-variant":"dark","header-text-variant":"light","body-bg-variant":"dark","body-text-variant":"light","footer-bg-variant":"danger","footer-text-variant":"light","ok-variant":"danger","ok-title":"DESTROY","cancel-title":"Cancel","cancel-variant":"dark"},on:{"ok":function($event){_vm.deleteRelated(attr)}}},[_c('p',{staticClass:"text-left"},[_vm._v("Are you sure you want to destroy this "+_vm._s(attr.label)+"?")])])],1)]),_vm._v(" "),(_vm.getRelatedRecords(attr) && _vm.editingHasOne !== attr.identifier)?_c('RecordTable',{attrs:{"schema":_vm.relatedSchema(attr),"records":[_vm.getRelatedRecords(attr)],"disableControls":true}}):_vm._e(),_vm._v(" "),(_vm.getRelatedRecords(attr) && _vm.editingHasOne === attr.identifier)?_c('RecordForm',{attrs:{"schema":_vm.relatedSchema(attr),"relatedAttr":attr,"record":_vm.getRelatedRecords(attr),"persistRecord":_vm.persistRecord,"cancelForm":_vm.cancelForm}}):_vm._e(),_vm._v(" "),(!_vm.getRelatedRecords(attr))?_c('div',{staticClass:"row"},[(!_vm.getRelatedRecords(attr) && _vm.editingHasOne !== attr.identifier)?_c('div',{staticClass:"col-lg-12 text-center"},[_c('p',{staticClass:"lead"},[_vm._v("\n              No "+_vm._s(_vm.relatedSchemaName(attr))+" defined.\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-success",on:{"click":function($event){_vm.editingHasOne = attr.identifier}}},[_c('i',{staticClass:"fa fa-fw fa-plus mr-1"}),_vm._v("\n              Add "+_vm._s(_vm.relatedSchemaName(attr))+"\n            ")])]):_vm._e(),_vm._v(" "),(!_vm.getRelatedRecords(attr) && _vm.editingHasOne === attr.identifier)?_c('div',{staticClass:"col-lg-12"},[_c('RecordForm',{attrs:{"schema":_vm.relatedSchema(attr),"relatedAttr":attr,"record":_vm.getNewRelatedRecord(attr),"persistRecord":_vm.persistRecord,"cancelForm":_vm.cancelForm}})],1):_vm._e()]):_vm._e()],1):_vm._e()]):_vm._e()}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EVI3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[(!_vm.schema._id)?_c('h2',[_vm._v("New Schema")]):_vm._e(),_vm._v(" "),(_vm.schema._id)?_c('h2',[_vm._v("Edit Schema")]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"card card-body bg-dark text-light border-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Schema Properties")]),_vm._v(" "),_c('small',{staticClass:"mb-2 form-text text-muted"},[_vm._v("Defines the core properties that are used to create a valid schema.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('FormInput',{attrs:{"label":"Label","placeholder":"Label","example":"Example: 'Odd Job'","required":"true","help":"The human-readable name for a single entity of this schema."},model:{value:(_vm.schema.label),callback:function ($$v) {_vm.$set(_vm.schema, "label", $$v)},expression:"schema.label"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-12"},[_c('FormInput',{attrs:{"label":"Plural Label","placeholder":"Plural Label","example":"Example: 'Odd Jobs'","required":"true","help":"The plural version of the Label attribute."},model:{value:(_vm.schema.label_plural),callback:function ($$v) {_vm.$set(_vm.schema, "label_plural", $$v)},expression:"schema.label_plural"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('FormInput',{attrs:{"label":"Identifier","placeholder":"Identifier","example":"Example: 'odd_job'","required":"true","help":"The lowercase-only version of the identifier with spaces instead of underscores."},model:{value:(_vm.schema.identifier),callback:function ($$v) {_vm.$set(_vm.schema, "identifier", $$v)},expression:"schema.identifier"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-12"},[_c('FormInput',{attrs:{"label":"Plural Identifier","placeholder":"Plural Identifier","example":"Example: 'odd_jobs'","required":"true","help":"The plural version Identifier attribute."},model:{value:(_vm.schema.identifier_plural),callback:function ($$v) {_vm.$set(_vm.schema, "identifier_plural", $$v)},expression:"schema.identifier_plural"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-12"},[_c('FormInput',{attrs:{"label":"Unique ID Prefix","placeholder":"Unique ID Prefix","example":"Example: 'OJ_'","required":"true","help":"A prefix used when generating unique IDs for this schema."},model:{value:(_vm.schema.unqiue_id_prefix),callback:function ($$v) {_vm.$set(_vm.schema, "unqiue_id_prefix", $$v)},expression:"schema.unqiue_id_prefix"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('FormInput',{attrs:{"label":"Icon","placeholder":"Icon","example":"Example: 'fa-globe'","help":"The name of a FontAwesome icon element."},model:{value:(_vm.schema.display.icon),callback:function ($$v) {_vm.$set(_vm.schema.display, "icon", $$v)},expression:"schema.display.icon"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('FormInput',{attrs:{"label":"Navbar Link","type":"BOOL","help":"Whether or not the schema has a header link."},model:{value:(_vm.schema.display.navbar_link),callback:function ($$v) {_vm.$set(_vm.schema.display, "navbar_link", $$v)},expression:"schema.display.navbar_link"}})],1)])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-lg-12"},[_c('button',{staticClass:"btn btn-outline-success btn-block",on:{"click":function($event){_vm.onSubmit()}}},[_c('i',{staticClass:"fa fa-fw mr-1 fa-check"}),_vm._v("\n              Submit\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('AttributeForm',{attrs:{"schema":_vm.schema}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F092":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('a',{attrs:{"href":'#/applications/' + _vm.model._id}},[_vm._v("Back")]),_vm._v(" "),_c('h2',[_vm._v("Application Edit - "+_vm._s(_vm.model.name))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Application Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Name"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n          Google Sheets ID\n\n        ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("ID of the Google Sheet used to build the application.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.google_sheets_id),expression:"model.google_sheets_id"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Google Sheets ID"},domProps:{"value":(_vm.model.google_sheets_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "google_sheets_id", $event.target.value)}}})]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("\n          Name\n          "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Update")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FEP3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("MGD5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__("/qDV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__("BYfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("C2Ba");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),

/***/ "FLwi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("Xn/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__("QUUa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__("dQYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("Vd1k");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),

/***/ "FbWj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView',{attrs:{"schema":_vm.schema}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FnWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Ikt9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61042b34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("wHjG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61042b34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FtZF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("5F5L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a5ebd99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("U0sF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a5ebd99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GCRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView',{attrs:{"schema":_vm.data.schema,"records":_vm.data.records}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GJjZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schema_new_components_layout_vue__ = __webpack_require__("ivcD");
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_2__schema_new_components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Schema - Edit' // title is now "HotSheets - Schema - Edit"
  },
  props: ['id'],
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('schema/selectSchema', { _id: this.id });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('schema/clearSelectedSchema');
  },
  data: function data() {
    var allSchemas = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
    var schema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allSchemas, { _id: this.id }));
    return { schema: schema };
  }
});

/***/ }),

/***/ "GZT8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("QdQm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8af21ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("YXai");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8af21ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H5cU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ZwZ8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55943cf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("v+OF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55943cf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("fcFS");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("PKAF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IOe2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_persistedstate__ = __webpack_require__("424j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__("Phyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user__ = __webpack_require__("6EED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__schema__ = __webpack_require__("UVtd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__record__ = __webpack_require__("FEP3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__notification__ = __webpack_require__("FLwi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__application__ = __webpack_require__("yJZh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__google_sheet__ = __webpack_require__("drpQ");











// Vuex Initialization
// TODO - should this be done elsewhere?
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_4__user__["a" /* default */],
    schema: __WEBPACK_IMPORTED_MODULE_5__schema__["a" /* default */],
    record: __WEBPACK_IMPORTED_MODULE_6__record__["a" /* default */],
    notification: __WEBPACK_IMPORTED_MODULE_7__notification__["a" /* default */],
    application: __WEBPACK_IMPORTED_MODULE_8__application__["a" /* default */],
    google_sheet: __WEBPACK_IMPORTED_MODULE_9__google_sheet__["a" /* default */]
  },
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_0_vuex_persistedstate__["a" /* default */])()]
}));

/***/ }),

/***/ "Ikt9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__ = __webpack_require__("b+fE");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "IqxW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._l((_vm.schema.attributes),function(attr){return (attr.datatype !== 'HAS_MANY' && attr.datatype !== 'HAS_ONE')?_c('div',{key:attr._id,class:_vm.getColspanCss(attr)},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n        "+_vm._s(attr.label)+"\n        "),(attr.required)?_c('span',{staticClass:"text-danger"},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(attr.help))]),_vm._v(" "),(attr.datatype === 'TEXT')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.record.attributes[attr.identifier]),expression:"record.attributes[attr.identifier]"}],staticClass:"form-control",attrs:{"type":"text","placeholder":attr.label},domProps:{"value":(_vm.record.attributes[attr.identifier])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.record.attributes, attr.identifier, $event.target.value)}}}):_vm._e(),_vm._v(" "),(attr.datatype === 'DATE')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.record.attributes[attr.identifier]),expression:"record.attributes[attr.identifier]"}],staticClass:"form-control",attrs:{"type":"date","placeholder":attr.label},domProps:{"value":(_vm.record.attributes[attr.identifier])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.record.attributes, attr.identifier, $event.target.value)}}}):_vm._e(),_vm._v(" "),(attr.datatype === 'TIME')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.record.attributes[attr.identifier]),expression:"record.attributes[attr.identifier]"}],staticClass:"form-control",attrs:{"type":"time","placeholder":attr.label},domProps:{"value":(_vm.record.attributes[attr.identifier])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.record.attributes, attr.identifier, $event.target.value)}}}):_vm._e(),_vm._v(" "),(attr.datatype === 'BOOL')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.record.attributes[attr.identifier]),expression:"record.attributes[attr.identifier]"}],staticClass:"form-control",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.record.attributes[attr.identifier])?_vm._i(_vm.record.attributes[attr.identifier],null)>-1:(_vm.record.attributes[attr.identifier])},on:{"change":function($event){var $$a=_vm.record.attributes[attr.identifier],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.record.attributes[attr.identifier]=$$a.concat([$$v]))}else{$$i>-1&&(_vm.record.attributes[attr.identifier]=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.record.attributes, attr.identifier, $$c)}}}}):_vm._e(),_vm._v(" "),(attr.datatype === 'NUMBER')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.record.attributes[attr.identifier]),expression:"record.attributes[attr.identifier]"}],staticClass:"form-control",attrs:{"type":"number","placeholder":attr.label},domProps:{"value":(_vm.record.attributes[attr.identifier])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.record.attributes, attr.identifier, $event.target.value)}}}):_vm._e(),_vm._v(" "),(attr.datatype === 'COLOR')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.record.attributes[attr.identifier]),expression:"record.attributes[attr.identifier]"}],staticClass:"form-control",attrs:{"type":"color","placeholder":attr.label},domProps:{"value":(_vm.record.attributes[attr.identifier])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.record.attributes, attr.identifier, $event.target.value)}}}):_vm._e(),_vm._v(" "),(attr.datatype === 'PHONE_NUMBER')?_c('masked-input',{staticClass:"form-control",attrs:{"type":"tel","placeholder":attr.label,"mask":"\\+\\1 (111) 111-1111"},model:{value:(_vm.record.attributes[attr.identifier]),callback:function ($$v) {_vm.$set(_vm.record.attributes, attr.identifier, $$v)},expression:"record.attributes[attr.identifier]"}}):_vm._e(),_vm._v(" "),(attr.datatype === 'BELONGS_TO')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.record.attributes[attr.identifier]),expression:"record.attributes[attr.identifier]"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.record.attributes, attr.identifier, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.schemaDropdown(attr.datatypeOptions.schema_id)),function(rec){return _c('option',{key:rec._id,domProps:{"value":rec._id}},[_vm._v(_vm._s(rec.attributes[attr.datatypeOptions.schema_attribute_identifier]))])})):_vm._e(),_vm._v(" "),(attr.datatype === 'TEXT_SELECT' || attr.datatype === 'NUMBER_SELECT')?_c('v-select',{staticClass:"bg-light text-dark",attrs:{"options":attr.datatypeOptions.dropdownOptions},model:{value:(_vm.record.attributes[attr.identifier]),callback:function ($$v) {_vm.$set(_vm.record.attributes, attr.identifier, $$v)},expression:"record.attributes[attr.identifier]"}}):_vm._e()],1)]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"col-lg-12 text-right"},[_c('button',{staticClass:"btn btn-outline-light mr-2",on:{"click":_vm.cancelForm}},[_c('i',{staticClass:"fa fa-fw fa-times mr-1"}),_vm._v("\n      Cancel\n    ")]),_vm._v(" "),(_vm.record._id)?_c('button',{staticClass:"btn btn-outline-success",on:{"click":function($event){_vm.persistRecord(_vm.schema, _vm.record, _vm.relatedAttr)}}},[_c('i',{staticClass:"fa fa-fw fa-plus mr-1"}),_vm._v("\n      Update "+_vm._s(_vm.schema.label)+"\n    ")]):_vm._e(),_vm._v(" "),(!_vm.record._id)?_c('button',{staticClass:"btn btn-outline-success",on:{"click":function($event){_vm.persistRecord(_vm.schema, _vm.record, _vm.relatedAttr)}}},[_c('i',{staticClass:"fa fa-fw fa-plus mr-1"}),_vm._v("\n      Create "+_vm._s(_vm.schema.label)+"\n    ")]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J47m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("bBbP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_711aecd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("knEz");
function injectStyle (ssrContext) {
  __webpack_require__("TwMe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-711aecd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_711aecd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("aPSQ");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("rrPM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__("kJiG");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("nHb0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KAVM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KE38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_esm__ = __webpack_require__("8wyc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pagination_vue__ = __webpack_require__("J47m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_foreach__ = __webpack_require__("P/uL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_foreach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_foreach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_default__ = __webpack_require__("l6+S");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var dataTypes = {};
var coreDataTypes = __webpack_require__("Mwzp");
__WEBPACK_IMPORTED_MODULE_6_lodash_foreach___default()(coreDataTypes.keys(), function (key) {
  var compName = key.replace(/^\.\//, "").replace(/\.js/, "");
  dataTypes[compName] = coreDataTypes(key).default;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-good-table',
  components: {
    VueGoodPagination: __WEBPACK_IMPORTED_MODULE_5__Pagination_vue__["a" /* default */]
  },
  props: {
    styleClass: { default: 'table table-bordered' },
    title: '',
    columns: {},
    rows: {},
    onClick: {},
    perPage: {},
    sortable: { default: true },
    paginate: { default: false },
    paginateOnTop: { default: false },
    lineNumbers: { default: false },
    defaultSortBy: { default: null },
    responsive: { default: true },
    rtl: { default: false },
    rowStyleClass: { default: null, type: [Function, String] },

    // search
    globalSearch: { default: false },
    searchTrigger: { default: null },
    externalSearchQuery: { default: null },
    globalSearchFn: { type: Function, default: null },
    // text options
    globalSearchPlaceholder: { default: 'Search Table' },

    nextText: { default: 'Next' },
    prevText: { default: 'Prev' },
    rowsPerPageText: { default: 'Rows per page:' },
    ofText: { default: 'of' },
    allText: { default: 'All' }
  },

  data: function data() {
    return {
      currentPage: 1,
      currentPerPage: 10,
      sortColumn: -1,
      sortType: 'asc',
      globalSearchTerm: '',
      columnFilters: {},
      filteredRows: [],
      timer: null,
      forceSearch: false,
      sortChanged: false,
      dataTypes: dataTypes || {}
    };
  },

  methods: {
    pageChanged: function pageChanged(pagination) {
      this.currentPage = pagination.currentPage;
      this.$emit('pageChanged', { currentPage: this.currentPage, total: Math.floor(this.rows.length / this.currentPerPage) });
    },
    perPageChanged: function perPageChanged(pagination) {
      this.currentPerPage = pagination.currentPerPage;
    },
    sort: function sort(index) {
      if (!this.isSortableColumn(index)) return;
      if (this.sortColumn === index) {
        this.sortType = this.sortType === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortType = 'asc';
        this.sortColumn = index;
      }
      this.sortChanged = true;
    },
    click: function click(row, index) {
      if (this.onClick) this.onClick(row, index);
    },
    searchTable: function searchTable() {
      if (this.searchTrigger == 'enter') {
        this.forceSearch = true;
        this.sortChanged = true;
      }
    },


    // field can be:
    // 1. function
    // 2. regular property - ex: 'prop'
    // 3. nested property path - ex: 'nested.prop'
    collect: function collect(obj, field) {

      //utility function to get nested property
      function dig(obj, selector) {
        var result = obj;
        var splitter = selector.split('.');
        for (var i = 0; i < splitter.length; i++) {
          if (typeof result === 'undefined') return undefined;else result = result[splitter[i]];
        }return result;
      }

      if (typeof field === 'function') return field(obj);else if (typeof field === 'string') return dig(obj, field);else return undefined;
    },
    collectFormatted: function collectFormatted(obj, column) {
      var value = this.collect(obj, column.field);

      if (value === undefined) return '';
      //lets format the resultant data
      var type = column.typeDef;
      return type.format(value, column);
    },
    formattedRow: function formattedRow(row) {
      var formattedRow = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.typedColumns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          if (col.field) {
            formattedRow[col.field] = this.collectFormatted(row, col);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formattedRow;
    },


    //Check if a column is sortable.
    isSortableColumn: function isSortableColumn(index) {
      var sortable = this.columns[index].sortable;
      var isSortable = typeof sortable === 'boolean' ? sortable : this.sortable;
      return isSortable;
    },


    //Get classes for the given header column.
    getHeaderClasses: function getHeaderClasses(column, index) {
      var isSortable = this.isSortableColumn(index);
      var classes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.getClasses(index, 'th'), {
        'sorting': isSortable,
        'sorting-desc': isSortable && this.sortColumn === index && this.sortType === 'desc',
        'sorting-asc': isSortable && this.sortColumn === index && this.sortType === 'asc'
      });
      return classes;
    },


    //Get classes for the given column index & element.
    getClasses: function getClasses(index, element) {
      var _typedColumns$index = this.typedColumns[index],
          typeDef = _typedColumns$index.typeDef,
          custom = _typedColumns$index[element + 'Class'];

      var isRight = typeDef.isRight;
      if (this.rtl) isRight = true;
      var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'right-align': isRight,
        'left-align': !isRight
      }, custom, !!custom);
      return classes;
    },


    //since vue doesn't detect property addition and deletion, we
    // need to create helper function to set property etc
    updateFilters: function updateFilters(column, value) {
      var _this = this;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this.$set(_this.columnFilters, column.field, value);
      }, 400);
    },


    //method to filter rows
    filterRows: function filterRows() {
      var _this2 = this;

      var computedRows = this.originalRows;

      if (this.hasFilterRow) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.typedColumns), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var col = _step2.value;

            if (col.filterable && this.columnFilters[col.field]) {
              computedRows = computedRows.filter(function (row) {

                // If column has a custom filter, use that.
                if (col.filter) {
                  return col.filter(_this2.collect(row, col.field), _this2.columnFilters[col.field]);
                } else {
                  // Use default filters
                  var typeDef = col.typeDef;
                  return typeDef.filterPredicate(_this2.collect(row, col.field), _this2.columnFilters[col.field]);
                }
              });
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      this.filteredRows = computedRows;
    },


    //get column's defined placeholder or default one
    getPlaceholder: function getPlaceholder(column) {
      var placeholder = column.placeholder || 'Filter ' + column.label;
      return placeholder;
    },
    getCurrentIndex: function getCurrentIndex(index) {
      return (this.currentPage - 1) * this.currentPerPage + index + 1;
    },
    getRowStyleClass: function getRowStyleClass(row) {
      var classes = '';
      this.onClick ? classes += 'clickable' : '';
      var rowStyleClasses = void 0;
      if (typeof this.rowStyleClass === 'function') {
        rowStyleClasses = this.rowStyleClass(row);
      } else {
        rowStyleClasses = this.rowStyleClass;
      }
      if (rowStyleClasses) {
        classes += ' ' + rowStyleClasses;
      }
      return classes;
    }
  },

  watch: {
    columnFilters: {
      handler: function handler(newObj) {
        this.filterRows();
      },
      deep: true
    },
    rows: {
      handler: function handler(newObj) {
        this.filterRows();
      },
      deep: true
    }

  },

  computed: {
    searchTerm: function searchTerm() {
      return this.externalSearchQuery != null ? this.externalSearchQuery : this.globalSearchTerm;
    },


    //
    globalSearchAllowed: function globalSearchAllowed() {
      if (this.globalSearch && !!this.globalSearchTerm && this.searchTrigger != 'enter') {
        return true;
      }

      if (this.externalSearchQuery != null && this.searchTrigger != 'enter') {
        return true;
      }

      if (this.forceSearch) {
        this.forceSearch = false;
        return true;
      }

      return false;
    },


    // to create a filter row, we need to
    // make sure that there is atleast 1 column
    // that requires filtering
    hasFilterRow: function hasFilterRow() {
      if (!this.globalSearch) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.columns), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var col = _step3.value;

            if (col.filterable) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      return false;
    },


    // this is done everytime sortColumn
    // or sort type changes
    //----------------------------------------
    processedRows: function processedRows() {
      var _this3 = this;

      var computedRows = this.filteredRows;

      // take care of the global filter here also
      if (this.globalSearchAllowed) {
        var filteredRows = [];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.originalRows), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var row = _step4.value;
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.columns), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var col = _step5.value;


                //if col has search disabled, 
                //skip the column.
                if (col.globalSearchDisabled) {
                  continue;
                }

                // if a search function is provided, 
                // use that for searching, otherwise, 
                // use the default search behavior
                if (this.globalSearchFn) {
                  var foundMatch = this.globalSearchFn(row, col, this.collectFormatted(row, col), this.searchTerm);
                  if (foundMatch) {
                    filteredRows.push(row);
                    break;
                  }
                } else {
                  if (String(this.collectFormatted(row, col)).toLowerCase().search(this.searchTerm.toLowerCase()) > -1) {
                    filteredRows.push(row);
                    break;
                  }
                }
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        computedRows = filteredRows;
      }

      //taking care of sort here only if sort has changed
      if (this.sortColumn !== -1 && this.isSortableColumn(this.sortColumn) && (

      // if search trigger is enter then we only sort
      // when enter is hit
      this.searchTrigger !== 'enter' || this.sortChanged)) {

        this.sortChanged = false;

        computedRows = computedRows.sort(function (x, y) {
          if (!_this3.columns[_this3.sortColumn]) return 0;

          var xvalue = _this3.collect(x, _this3.columns[_this3.sortColumn].field);
          var yvalue = _this3.collect(y, _this3.columns[_this3.sortColumn].field);
          var typeDef = _this3.typedColumns[_this3.sortColumn].typeDef;
          return typeDef.compare(xvalue, yvalue, _this3.columns[_this3.sortColumn]) * (_this3.sortType === 'desc' ? -1 : 1);
        });
      }

      // if the filtering is event based, we need to maintain filter
      // rows
      if (this.searchTrigger === 'enter') {
        this.filteredRows = computedRows;
      }

      return computedRows;
    },
    paginated: function paginated() {
      var paginatedRows = this.processedRows;

      if (this.paginate) {
        var pageStart = (this.currentPage - 1) * this.currentPerPage;

        // in case of filtering we might be on a page that is
        // not relevant anymore
        // also, if setting to all, current page will not be valid
        if (pageStart >= this.processedRows.length || this.currentPerPage === -1) {
          this.currentPage = 1;
          pageStart = 0;
        }

        //calculate page end now
        var pageEnd = paginatedRows.length + 1;

        //if the setting is set to 'all'
        if (this.currentPerPage !== -1) {
          pageEnd = this.currentPage * this.currentPerPage;
        }

        paginatedRows = paginatedRows.slice(pageStart, pageEnd);
      }
      return paginatedRows;
    },
    originalRows: function originalRows() {
      var rows = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.rows));

      // we need to preserve the original index of rows so lets do that
      for (var index = 0; index < rows.length; index++) {
        rows[index].originalIndex = index;
      }

      return rows;
    },
    typedColumns: function typedColumns() {
      var columns = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.columns, []);
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(columns), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var column = _step6.value;

          column.typeDef = this.dataTypes[column.type] || __WEBPACK_IMPORTED_MODULE_7__types_default__["default"];
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return columns;
    }
  },

  mounted: function mounted() {
    this.filteredRows = this.originalRows;

    if (this.perPage) {
      this.currentPerPage = this.perPage;
    }

    //take care of default sort on mount
    if (this.defaultSortBy) {
      for (var index = 0; index < this.columns.length; index++) {
        var col = this.columns[index];
        if (col.field === this.defaultSortBy.field) {
          this.sortColumn = index;
          this.sortType = this.defaultSortBy.type || 'asc';
          this.sortChanged = true;
          break;
        }
      }
    }
  }
});

/***/ }),

/***/ "Ki2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_vue__ = __webpack_require__("OaTr");
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_2__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Schema - Records' // title is now "HotSheets - Schema - Records"
  },
  props: ['id'],
  computed: {
    data: function data() {
      var schemas = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
      var schema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(schemas, { _id: this.id });
      var allRecords = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['record/collection'];
      var records = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(allRecords, function (r) {
        return r.schema_id === schema._id;
      });
      return { schema: schema, records: records };
    }
  }
});

/***/ }),

/***/ "KlSj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Project Module Getters
var getters = {
  fetching: function fetching(state) {
    return state.fetching;
  },
  token: function token(state) {
    return state.token || false;
  },
  isAuthenticated: function isAuthenticated(state) {
    return state.googleAuthenticated;
  },
  currentUser: function currentUser(state) {
    return state.googleUser;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "Kx1p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("oeT9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e95bd970_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("C52G");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e95bd970_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M/Ab":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5952aa40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("aJHI");
function injectStyle (ssrContext) {
  __webpack_require__("t4xi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5952aa40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MCP+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_factory__ = __webpack_require__("skhC");


// // // //

// Creates new AbstractFactory instance
var ApplicationFactory = new __WEBPACK_IMPORTED_MODULE_0__lib_factory__["a" /* default */]({
  API_ROOT: '/api/applications',
  REDIRECT_SUCCESS: '#/applications',
  messages: {
    CREATE_SUCCESS: 'Created Application.',
    UPDATE_SUCCESS: 'Updated Application.',
    DESTROY_SUCCESS: 'Destroyed Application.'
  }
});

// // // //

/* harmony default export */ __webpack_exports__["a"] = (ApplicationFactory);

/***/ }),

/***/ "MGD5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// actions
// functions that causes side effects and can involve asynchronous operations.
var actions = {};

// // // //

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ "Mwzp":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./date.js": "4JqT",
	"./decimal.js": "yi5Z",
	"./default.js": "l6+S",
	"./number.js": "a3Kw",
	"./percentage.js": "jLkh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Mwzp";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routers__ = __webpack_require__("Q3uA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






// QUESTION - ??
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

window.store = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]; // TODO - remove - debug only

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  // store, // Vuex Store - QUESTION - why is this not available to all child components as `this.$store`?
  router: __WEBPACK_IMPORTED_MODULE_3__routers__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NKD+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NnBr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory__ = __webpack_require__("MCP+");


// // // //

// actions
// functions that causes side effects and can involve asynchronous operations.
var actions = {
  fetchCollection: function fetchCollection(_ref) {
    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_0__factory__["a" /* default */].fetchCollection({ commit: commit });
  },

  create: function create(_ref2, attributes) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0__factory__["a" /* default */].create({ commit: commit }, attributes);
  },

  update: function update(_ref3, attributes) {
    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_0__factory__["a" /* default */].update({ commit: commit }, attributes);
  }

  // // // //

};/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ "O2IH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Bls+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4e6d560_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("STRh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4e6d560_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O8MU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("OGOo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac729048_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("eD4o");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac729048_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O9rZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormInput_vue__ = __webpack_require__("X+bO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ade371_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormInput_vue__ = __webpack_require__("hQJW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ade371_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OGOo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'application_new',
  data: function data() {
    return {
      model: {}
    };
  },

  methods: {
    formSubmit: function formSubmit() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('application/persist', { app: this.model });
    }
  }
});

/***/ }),

/***/ "OLHt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// actions
// functions that causes side effects and can involve asynchronous operations.
var actions = {};

// // // //

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ "OaTr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("spmD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2010cb68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("t/gG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2010cb68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OdUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// TODO - this should be split into a series of smaller components
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Navbar',
  computed: {
    navSchemas: function navSchemas() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'], function (s) {
        return s.display.navbar_link;
      });
    }
    // currentUser () {
    // return store.getters['auth/currentUser']
    // }
    // isAuthenticated () {
    // return store.getters['auth/isAuthenticated']
    // }

  }
});

/***/ }),

/***/ "P/SL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_RecordTable__ = __webpack_require__("/wTD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_record_new_components_record_form__ = __webpack_require__("bsFJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['schema', 'record'],
  components: {
    RecordTable: __WEBPACK_IMPORTED_MODULE_2__components_RecordTable__["a" /* default */],
    RecordForm: __WEBPACK_IMPORTED_MODULE_3__containers_record_new_components_record_form__["a" /* default */]
  },
  data: function data() {
    return {
      editingHasOne: null
    };
  },

  methods: {
    deleteRelated: function deleteRelated(attr) {
      // Removes the association from the current record
      this.record.attributes[attr.identifier] = null;
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('schema/persist', { schema: this.schema });

      // Deletes the associated record
      var relatedRecord = this.getRelatedRecords(attr);
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('record/destroy', { record: relatedRecord });
    },
    persistRecord: function persistRecord(schema, record, relatedAttr) {
      if (record._id) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('record/persist', { schema: schema, record: record, redirect: false });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('record/persist', { schema: schema, record: record, redirect: false });
        this.record.attributes[relatedAttr.identifier] = record._id;
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('schema/persist', { schema: this.schema });
      }
      this.editingHasOne = false;
    },
    cancelForm: function cancelForm() {
      this.editingHasOne = false;
    },
    getLinkedSchemaHref: function getLinkedSchemaHref(attr, record_id) {
      // TODO - abstract to component
      var allRecords = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['record/collection'];
      var allSchemas = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
      var record = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allRecords, { _id: record_id });
      if (!record) return;
      var schema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allSchemas, { _id: record.schema_id });
      return '#/schemas/' + schema._id + '/records/' + record._id;
    },
    getLinkedSchemaLabel: function getLinkedSchemaLabel(attr, record_id) {
      // TODO - abstract to component
      var allRecords = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['record/collection'];
      var record = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allRecords, { _id: record_id });
      if (!record) return;

      var identifier = attr.datatypeOptions.schema_attribute_identifier;
      return record.attributes[identifier];
    },
    relatedSchema: function relatedSchema(attr) {
      // TODO - this should be moved into a getter
      var allSchemas = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
      var relatedSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allSchemas, { _id: attr.datatypeOptions.schema_id });
      return relatedSchema;
    },
    relatedSchemaName: function relatedSchemaName(attr) {
      // TODO - this should be moved into a getter
      var allSchemas = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
      var relatedSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allSchemas, { _id: attr.datatypeOptions.schema_id });
      if (attr.datatype === 'HAS_MANY') {
        return relatedSchema.label_plural;
      } else {
        return relatedSchema.label;
      }
    },
    getRelatedRecords: function getRelatedRecords(attr) {
      var _this = this;

      // TODO - this should be moved into a getter
      var allSchemas = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
      var allRecords = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['record/collection'];
      var relatedSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allSchemas, { _id: attr.datatypeOptions.schema_id });

      // TODO - handle other attr types
      if (attr.datatype === 'HAS_MANY') {
        var relatedRecords = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(allRecords, function (r) {
          return r.schema_id === relatedSchema._id && r.attributes[_this.schema.identifier + '_id'] === _this.record._id;
        });
        return relatedRecords;
      } else if (attr.datatype === 'HAS_ONE') {
        var relatedRecord = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allRecords, { _id: this.record.attributes[attr.identifier] });
        return relatedRecord;
      }
    },
    getNewRelatedRecord: function getNewRelatedRecord(attr) {
      // TODO - this should be moved into a getter
      var allSchemas = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
      var relatedSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allSchemas, { _id: attr.datatypeOptions.schema_id });
      return { schema_id: relatedSchema._id, _id: null, attributes: {} };
    }
  }
});

/***/ }),

/***/ "PD9V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_factory__ = __webpack_require__("skhC");


// // // //

// Creates new AbstractFactory instance
var GoogleSheetFactory = new __WEBPACK_IMPORTED_MODULE_0__lib_factory__["a" /* default */]({
  API_ROOT: '/api/google_sheet',
  REDIRECT_SUCCESS: '#/google_sheet',
  messages: {
    CREATE_SUCCESS: 'Created Google Sheet.',
    UPDATE_SUCCESS: 'Updated Google Sheet.',
    DESTROY_SUCCESS: 'Destroyed Google Sheet.'
  }
});

// // // //

/* harmony default export */ __webpack_exports__["a"] = (GoogleSheetFactory);

/***/ }),

/***/ "PGNy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Google Sheet Module Getters
var getters = {
  collection: function collection(state) {
    return state.collection;
  },
  current: function current(state) {
    return state.current;
  },
  fetching: function fetching(state) {
    return state.fetching;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "PKAF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PL+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeItem_vue__ = __webpack_require__("lxpf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ee34b89_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeItem_vue__ = __webpack_require__("SGAl");
function injectStyle (ssrContext) {
  __webpack_require__("8EGV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ee34b89"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ee34b89_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Phyb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("zzTB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__("9YOS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__("KlSj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("WjrJ");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),

/***/ "Q0gT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("+UDm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8df3998e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("Ysko");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8df3998e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q3uA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("3x7a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__("VKSz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user__ = __webpack_require__("w1je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__schema__ = __webpack_require__("6QP5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__application__ = __webpack_require__("4pT1");



// Module routes






// Vue Router setup
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// Exports new Router instance
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [__WEBPACK_IMPORTED_MODULE_2__main__["a" /* MainHomeRoute */], __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* AuthLoginRoute */], __WEBPACK_IMPORTED_MODULE_3__auth__["b" /* AuthRegisterRoute */], __WEBPACK_IMPORTED_MODULE_4__user__["a" /* UserListRoute */], __WEBPACK_IMPORTED_MODULE_4__user__["b" /* UserShowRoute */], __WEBPACK_IMPORTED_MODULE_5__schema__["e" /* SchemaListRoute */], __WEBPACK_IMPORTED_MODULE_5__schema__["f" /* SchemaNewRoute */], __WEBPACK_IMPORTED_MODULE_5__schema__["g" /* SchemaShowRoute */], __WEBPACK_IMPORTED_MODULE_5__schema__["d" /* SchemaEditRoute */], __WEBPACK_IMPORTED_MODULE_5__schema__["b" /* RecordNewRoute */], __WEBPACK_IMPORTED_MODULE_5__schema__["a" /* RecordEditRoute */], __WEBPACK_IMPORTED_MODULE_5__schema__["c" /* RecordShowRoute */], __WEBPACK_IMPORTED_MODULE_6__application__["b" /* ApplicationListRoute */], __WEBPACK_IMPORTED_MODULE_6__application__["c" /* ApplicationNewRoute */], __WEBPACK_IMPORTED_MODULE_6__application__["d" /* ApplicationShowRoute */], __WEBPACK_IMPORTED_MODULE_6__application__["a" /* ApplicationEditRoute */]]
}));

/***/ }),

/***/ "QERL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormSubmit'
});

/***/ }),

/***/ "QR+I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__ = __webpack_require__("RQ0x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Users - Show' // title is now "RCOS - Loading..."
  },
  props: ['id'],
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('user/fetchModel', this.id);
    }
  },
  computed: {
    model: function model() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['user/current'];
    }
  }
});

/***/ }),

/***/ "QUUa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Notification Module State
var state = {
  collection: [
    // Notification examples:
    // { dismissible: true, strong: 'Warning', message: 'Something went wrong.', context: 'warning' },
    // { dismissible: true, strong: 'Info', message: 'Something went wrong.', context: 'info' },
    // { dismissible: true, strong: 'Danger!', message: 'Something went wrong.', context: 'danger' }
  ]
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ "QVUP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_vue__ = __webpack_require__("ivcD");
//
//
//
//
//
//
//

// import _ from 'lodash'



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_1__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Schemas - New' // title is now "HotSheets - Schemas - New"
  },
  data: function data() {
    var schema = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['schema/new'];
    return { schema: schema };
  }
});

/***/ }),

/***/ "QdQm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__ = __webpack_require__("9ix5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Schemas' // title is now "HotSheets - Schemas"
  },
  computed: {
    collection: function collection() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
    }
  }
});

/***/ }),

/***/ "RL/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("Thxp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a399292a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("B4Cs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a399292a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RQ0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("mpQj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b478b258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("Yi7G");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b478b258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RSts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Reyk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeForm_vue__ = __webpack_require__("zgiQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e425d1da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeForm_vue__ = __webpack_require__("v9+0");
function injectStyle (ssrContext) {
  __webpack_require__("6QA3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e425d1da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RxIX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h2',[_vm._v("User List")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.fetching)?_c('p',{staticClass:"lead"},[_c('i',{staticClass:"fa fa-2x fa-spin fa-spinner"})]):_vm._e(),_vm._v(" "),(!_vm.collection[0])?_c('p',{staticClass:"lead"},[_vm._v("\n        EMPTY\n      ")]):_vm._e(),_vm._v(" "),_c('ListView',{attrs:{"collection":_vm.collection}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SDS1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_factory__ = __webpack_require__("skhC");


// // // //

// Creates new AbstractFactory instance
var UserFactory = new __WEBPACK_IMPORTED_MODULE_0__lib_factory__["a" /* default */]({
  API_ROOT: '/api/users',
  REDIRECT_SUCCESS: '#/users',
  messages: {
    CREATE_SUCCESS: 'Created User.',
    UPDATE_SUCCESS: 'Updated User.',
    DESTROY_SUCCESS: 'Destroyed User.'
  }
});

// // // //

/* harmony default export */ __webpack_exports__["a"] = (UserFactory);

/***/ }),

/***/ "SGAl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.className},[_c('div',{staticClass:"row d-flex align-items-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-5"},[(_vm.item.datatype === 'TEXT')?_c('span',{staticClass:"badge"},[_c('i',{staticClass:"fa fa-quote-left mr-2"}),_vm._v("\n        "+_vm._s(_vm.item.label)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.item.datatype === 'TEXT_SELECT')?_c('span',{staticClass:"badge"},[_c('i',{staticClass:"fa fa-list mr-2"}),_vm._v("\n        "+_vm._s(_vm.item.label)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.item.datatype === 'NUMBER')?_c('span',{staticClass:"badge"},[_c('i',{staticClass:"fa fa-hashtag mr-2"}),_vm._v("\n        "+_vm._s(_vm.item.label)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.item.datatype === 'NUMBER_SELECT')?_c('span',{staticClass:"badge"},[_c('i',{staticClass:"fa fa-list-ol mr-2"}),_vm._v("\n        "+_vm._s(_vm.item.label)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.item.datatype === 'BELONGS_TO')?_c('span',{staticClass:"badge"},[_c('i',{staticClass:"fa fa-link mr-2"}),_vm._v("\n        "+_vm._s(_vm.item.label)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.item.datatype === 'HAS_ONE')?_c('span',{staticClass:"badge"},[_c('i',{staticClass:"fa fa-link mr-2"}),_vm._v("\n        "+_vm._s(_vm.item.label)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.item.datatype === 'HAS_MANY')?_c('span',{staticClass:"badge"},[_c('i',{staticClass:"fa fa-link mr-2"}),_vm._v("\n        "+_vm._s(_vm.item.label)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.item.datatype === 'DATE')?_c('span',{staticClass:"badge"},[_c('i',{staticClass:"fa fa-calendar-o mr-2"}),_vm._v("\n        "+_vm._s(_vm.item.label)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.item.datatype === 'COLOR')?_c('span',{staticClass:"badge"},[_c('i',{staticClass:"fa fa-eyedropper mr-2"}),_vm._v("\n        "+_vm._s(_vm.item.label)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.item.datatype === 'TIME')?_c('span',{staticClass:"badge"},[_c('i',{staticClass:"fa fa-clock-o mr-2"}),_vm._v("\n        "+_vm._s(_vm.item.label)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.item.datatype === 'PHONE_NUMBER')?_c('span',{staticClass:"badge"},[_c('i',{staticClass:"fa fa-phone mr-2"}),_vm._v("\n        "+_vm._s(_vm.item.label)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.item.datatype === 'BOOL')?_c('span',{staticClass:"badge"},[_c('i',{staticClass:"fa fa-check-square-o mr-2"}),_vm._v("\n        "+_vm._s(_vm.item.label)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[(_vm.item.required)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",modifiers:{"hover":true,"top":true}}],staticClass:"badge",attrs:{"title":"Required"}},[_c('i',{staticClass:"fa fa-asterisk text-danger"})]):_vm._e(),_vm._v(" "),(_vm.item.unique)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",modifiers:{"hover":true,"top":true}}],staticClass:"badge",attrs:{"title":"Unique"}},[_c('i',{staticClass:"fa fa-snowflake-o text-info"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 text-right controls"},[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",modifiers:{"hover":true,"top":true}}],staticClass:"btn btn-sm btn-outline-secondary",attrs:{"title":"Edit"},on:{"click":function($event){_vm.edit(_vm.item)}}},[_c('i',{staticClass:"fa fa-fw fa-pencil"})]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",modifiers:{"hover":true,"top":true}}],staticClass:"btn btn-sm btn-outline-danger",attrs:{"title":"Remove"},on:{"click":function($event){_vm.remove(_vm.item)}}},[_c('i',{staticClass:"fa fa-fw fa-trash"})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-1 text-left d-flex align-items-center"},[_c('i',{staticClass:"fa fa-lg fa-fw fa-bars mr-3"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "STRh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView',{attrs:{"schema":_vm.data.schema,"record":_vm.data.record}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TEDj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("3URG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcb725ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("NKD+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcb725ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TF4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView',{attrs:{"schema":_vm.data.schema,"record":_vm.data.record}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TRCR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Google Sheet Module State
var state = {
  collection: [],
  current: {},
  fetching: false,
  api_loaded: false,
  currentSheet: {}
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ "Thxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collection']
});

/***/ }),

/***/ "TkMW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container h-100"},[_c('div',{staticClass:"row d-flex justify-content-center"},[_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card card-body bg-dark text-light border-light"},[_c('h4',{staticClass:"card-title"},[_vm._v("Sign In")]),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-outline-primary",on:{"click":function($event){_vm.authenticate()}}},[_c('i',{staticClass:"fa fa-google"}),_vm._v("\n                  Sign In with Google\n                ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TlFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Google Sheet Module mutations
var mutations = {
  fetching: function fetching(state, isFetching) {
    state.fetching = isFetching;
  },
  sync: function sync(state, collection) {
    state.collection = collection;
  },
  current: function current(state, attributes) {
    state.current = attributes;
  },
  api_loaded: function api_loaded(state, is_loaded) {
    state.api_loaded = is_loaded;
  },
  currentSheet: function currentSheet(state, sheet) {
    state.currentSheet = sheet;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "TwMe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U0sF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('LayoutView')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UQhV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__ = __webpack_require__("2z2G");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'auth_register',
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Auth - Register'
  }
});

/***/ }),

/***/ "UVtd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("OLHt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__("rIoT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__("3P4K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("ix+C");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),

/***/ "UY6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Project Module mutations
var mutations = {
  fetching: function fetching(state, isFetching) {
    state.fetching = isFetching;
  },
  sync: function sync(state, collection) {
    state.collection = collection;
  },
  current: function current(state, attributes) {
    state.current = attributes;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "Ua4y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("55l9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f751d7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("F092");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f751d7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VGg9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VKSz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthLoginRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AuthRegisterRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_auth_login__ = __webpack_require__("TEDj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_auth_register__ = __webpack_require__("x/mD");
// Auth Containers



var AuthLoginRoute = {
  path: '/auth/login',
  component: __WEBPACK_IMPORTED_MODULE_0__containers_auth_login__["a" /* default */]
};

var AuthRegisterRoute = {
  path: '/auth/register',
  component: __WEBPACK_IMPORTED_MODULE_1__containers_auth_register__["a" /* default */]
};

/***/ }),

/***/ "VUp7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__ = __webpack_require__("ibQm");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Users' // title is now "RCOS - Users"
  }
});

/***/ }),

/***/ "Vd1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


// // // //

// removeNotification
// Helper function used to remove a notification from state.collection
function removeNotification(collection, id) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(collection, function (e) {
    return e.id !== id;
  });
}

// // // //

// Notification Module mutations
var mutations = {
  // Adds a notification to state.collection
  add: function add(state, notification) {
    // Assigns unique ID to notification
    // this is used for removing the notification after a timeout
    var uniqueId = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId();
    notification.id = uniqueId;

    // Adds the notification to state.collection
    state.collection.push(notification);

    // Removes the notification after
    setTimeout(function () {
      state.collection = removeNotification(state.collection, uniqueId);
    }, notification.timeout || 2500);
  },


  // Removes a Notification from state.collection
  remove: function remove(state, notificationId) {
    state.collection = removeNotification(state.collection, notificationId);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "VeKM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("s1DK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be086f5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("ZrvJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be086f5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VlU1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_vue__ = __webpack_require__("DIqs");
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_2__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Schema - New Record' // title is now "HotSheets - Schema - New Record"
  },
  props: ['id', 'record_id'],
  computed: {
    data: function data() {
      var allSchemas = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
      var schema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allSchemas, { _id: this.id });

      var allRecords = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['record/collection'];
      var record = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allRecords, { _id: this.record_id });

      return { schema: schema, record: record };
    }
  }
});

/***/ }),

/***/ "W/Hi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("VUp7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_313fc38c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("RSts");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_313fc38c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WjrJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routers__ = __webpack_require__("Q3uA");



// Project Module mutations
var mutations = {
  fetching: function fetching(state, isFetching) {
    state.fetching = isFetching;
  },
  set_token: function set_token(state, jsonwebtoken) {
    state.token = jsonwebtoken;
  },
  flush_token: function flush_token(state) {
    state.token = null;
  },
  set_user: function set_user(state, user) {
    state.user = user;
  },
  googleAuthenticated: function googleAuthenticated(state, status) {
    state.googleAuthenticated = status;
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('auth/getGoogleUser');
  },
  googleUser: function googleUser(state, user) {
    state.googleUser = user;
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('google_sheet/loadSheetAPI');
    __WEBPACK_IMPORTED_MODULE_1__routers__["a" /* default */].push('/');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "Wo2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__list_vue__ = __webpack_require__("Q0gT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    collection: function collection() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['user/collection'];
    },
    fetching: function fetching() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['user/fetching'];
    }
  },
  mounted: function mounted() {
    return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('user/fetchCollection');
  },
  components: {
    ListView: __WEBPACK_IMPORTED_MODULE_0__list_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "Wxyc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__ = __webpack_require__("XYWh");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "X+bO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['required', 'label', 'type', 'example', 'help', 'ex', 'help', 'placeholder', 'value'],
  methods: {
    updateModel: function updateModel() {
      if (this.type === 'BOOL') {
        this.$emit('input', this.$refs.input_el.checked);
      } else {
        this.$emit('input', this.$refs.input_el.value);
      }
    }
  }
});

/***/ }),

/***/ "X7DP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XYWh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("50KH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf2ff9f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("tQY2");
function injectStyle (ssrContext) {
  __webpack_require__("scBT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf2ff9f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XazP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Wxyc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5142c0b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("1WY9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5142c0b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xn/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// actions
// functions that causes side effects and can involve asynchronous operations.
// TODO - delete if no actions are required
var actions = {};

// // // //

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ "XpA9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView',{attrs:{"model":_vm.model}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xrce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView',{attrs:{"schema":_vm.schema}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YXai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView',{attrs:{"collection":_vm.collection}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Yi7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('a',{attrs:{"href":"#/users"}},[_vm._v("Back")]),_vm._v(" "),_c('h2',[_vm._v("User Show - "+_vm._s(_vm.model.name))]),_vm._v(" "),_c('hr')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ysko":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.collection),function(m){return _c('div',{staticClass:"col-lg-2 mt-2"},[_c('div',{staticClass:"card card-body bg-light"},[_c('a',{attrs:{"href":'#/users/' + m._id}},[_vm._v(_vm._s(m.name))])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZHbe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['item'],
  methods: {
    dismiss: function dismiss(id) {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('notification/remove', id);
    }
  }
});

/***/ }),

/***/ "ZrvJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h2',[_vm._v("New "+_vm._s(_vm.schema.label))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('RecordForm',{attrs:{"schema":_vm.schema,"record":_vm.record,"persistRecord":_vm.persistRecord,"cancelForm":_vm.cancelForm}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZwZ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__ = __webpack_require__("zp1C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'application_list',
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Applications' // title is now "NAME - Applications"
  },
  computed: {
    collection: function collection() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['application/collection'];
    }
  }
});

/***/ }),

/***/ "aJHI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('AppNavbar'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('Notification')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aPSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__("rKsW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),

/***/ "aUdD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"good-table",class:{'rtl': _vm.rtl}},[_c('div',{class:{'responsive': _vm.responsive}},[(_vm.title || _vm.$slots['table-actions'])?_c('div',{staticClass:"table-header clearfix"},[_c('h2',{staticClass:"table-title pull-left"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"actions pull-right"},[_vm._t("table-actions")],2)]):_vm._e(),_vm._v(" "),(_vm.paginate && _vm.paginateOnTop)?_c('vue-good-pagination',{attrs:{"perPage":_vm.perPage,"rtl":_vm.rtl,"total":_vm.processedRows.length,"nextText":_vm.nextText,"prevText":_vm.prevText,"rowsPerPageText":_vm.rowsPerPageText,"ofText":_vm.ofText,"allText":_vm.allText},on:{"page-changed":_vm.pageChanged,"per-page-changed":_vm.perPageChanged}}):_vm._e(),_vm._v(" "),_c('table',{ref:"table",class:_vm.styleClass},[_c('thead',[(_vm.globalSearch && _vm.externalSearchQuery == null)?_c('tr',[_c('td',{attrs:{"colspan":_vm.lineNumbers ? _vm.columns.length + 1: _vm.columns.length}},[_c('div',{staticClass:"global-search"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.globalSearchTerm),expression:"globalSearchTerm"}],staticClass:"form-control global-search-input",attrs:{"type":"text","placeholder":_vm.globalSearchPlaceholder},domProps:{"value":(_vm.globalSearchTerm)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.searchTable()},"input":function($event){if($event.target.composing){ return; }_vm.globalSearchTerm=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),_c('tr',[(_vm.lineNumbers)?_c('th',{staticClass:"line-numbers"}):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column,index){return (!column.hidden)?_c('th',{key:column.label,class:_vm.getHeaderClasses(column, index),style:({width: column.width ? column.width : 'auto'}),on:{"click":function($event){_vm.sort(index)}}},[_vm._t("table-column",[_c('span',[_vm._v(_vm._s(column.label))])],{column:column})],2):_vm._e()}),_vm._v(" "),_vm._t("thead-tr")],2),_vm._v(" "),(_vm.hasFilterRow)?_c('tr',[(_vm.lineNumbers)?_c('th'):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column,index){return (!column.hidden)?_c('th',{key:column.label},[(column.filterable)?_c('div',{class:_vm.getHeaderClasses(column, index)},[(!column.filterDropdown)?_c('input',{attrs:{"type":"text","placeholder":_vm.getPlaceholder(column)},domProps:{"value":_vm.columnFilters[column.field]},on:{"input":function($event){_vm.updateFilters(column, $event.target.value)}}}):_vm._e(),_vm._v(" "),(column.filterDropdown && typeof(column.filterOptions[0]) !== 'object')?_c('select',{domProps:{"value":_vm.columnFilters[column.field]},on:{"input":function($event){_vm.updateFilters(column, $event.target.value)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.getPlaceholder(column)))]),_vm._v(" "),_vm._l((column.filterOptions),function(option){return _c('option',{key:option,domProps:{"value":option}},[_vm._v("\n                    "+_vm._s(option)+"\n                  ")])})],2):_vm._e(),_vm._v(" "),(column.filterDropdown && typeof(column.filterOptions[0]) === 'object')?_c('select',{domProps:{"value":_vm.columnFilters[column.field]},on:{"input":function($event){_vm.updateFilters(column, $event.target.value)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.getPlaceholder(column)))]),_vm._v(" "),_vm._l((column.filterOptions),function(option){return _c('option',{key:option,domProps:{"value":option.value}},[_vm._v(_vm._s(option.text))])})],2):_vm._e()]):_vm._e()]):_vm._e()})],2):_vm._e()]),_vm._v(" "),_c('tbody',[_vm._l((_vm.paginated),function(row,index){return _c('tr',{key:index,class:_vm.getRowStyleClass(row),on:{"click":function($event){_vm.click(row, index)}}},[(_vm.lineNumbers)?_c('th',{staticClass:"line-numbers"},[_vm._v(_vm._s(_vm.getCurrentIndex(index)))]):_vm._e(),_vm._v(" "),_vm._t("table-row-before",null,{row:row,index:index}),_vm._v(" "),_vm._t("table-row",_vm._l((_vm.columns),function(column,i){return (!column.hidden && column.field)?_c('td',{key:column.label,class:_vm.getClasses(i, 'td')},[(!column.html)?_c('span',[_vm._v(_vm._s(_vm.collectFormatted(row, column)))]):_vm._e(),_vm._v(" "),(column.html)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.collect(row, column.field))}}):_vm._e()]):_vm._e()}),{row:row,formattedRow:_vm.formattedRow(row),index:index}),_vm._v(" "),_vm._t("table-row-after",null,{row:row,index:index})],2)}),_vm._v(" "),(_vm.processedRows.length === 0)?_c('tr',[_c('td',{attrs:{"colspan":_vm.columns.length}},[_vm._t("emptystate",[_c('div',{staticClass:"center-align text-disabled"},[_vm._v("\n                No data for table.\n              ")])])],2)]):_vm._e()],2)]),_vm._v(" "),(_vm.paginate && !_vm.paginateOnTop)?_c('vue-good-pagination',{attrs:{"perPage":_vm.perPage,"rtl":_vm.rtl,"total":_vm.processedRows.length,"nextText":_vm.nextText,"prevText":_vm.prevText,"rowsPerPageText":_vm.rowsPerPageText,"ofText":_vm.ofText,"allText":_vm.allText},on:{"page-changed":_vm.pageChanged,"per-page-changed":_vm.perPageChanged}}):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"global-search-icon"},[_c('div',{staticClass:"magnifying-glass"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aZ34":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__ = __webpack_require__("O8MU");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'application_new',
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Application - New' // title is now "TITLE - Application - New"
  },
  data: function data() {
    return {
      model: {}
    };
  }
});

/***/ }),

/***/ "b+fE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("vwq3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26424684_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("xYjX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26424684_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bBbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-good-pagination',
  props: {
    styleClass: { default: 'table table-bordered' },
    total: { default: null },
    perPage: {},
    rtl: { default: false },

    // text options
    nextText: { default: 'Next' },
    prevText: { default: 'Prev' },
    rowsPerPageText: { default: 'Rows per page:' },
    ofText: { default: 'of' },
    allText: { default: 'All' }
  },

  data: function data() {
    return {
      currentPage: 1,
      currentPerPage: 10
    };
  },

  methods: {
    nextPage: function nextPage() {
      if (this.currentPerPage === -1) return;
      if (this.nextIsPossible) ++this.currentPage;
      this.pageChanged();
    },
    previousPage: function previousPage() {
      if (this.currentPage > 1) --this.currentPage;
      this.pageChanged();
    },
    pageChanged: function pageChanged() {
      this.$emit('page-changed', { currentPage: this.currentPage });
    },
    perPageChanged: function perPageChanged(event) {
      if (event) {
        this.currentPerPage = parseInt(event.target.value);
      }
      this.$emit('per-page-changed', { currentPerPage: this.currentPerPage });
    }
  },

  watch: {
    perPage: function perPage() {
      if (this.perPage) {
        this.currentPerPage = this.perPage;
      } else {
        //reset to default
        this.currentPerPage = 10;
      }
      this.perPageChanged();
    }
  },

  computed: {
    paginatedInfo: function paginatedInfo() {
      if (this.currentPerPage === -1) {
        return '1 - ' + this.total + ' ' + this.ofText + ' ' + this.total;
      }
      var first = (this.currentPage - 1) * this.currentPerPage ? (this.currentPage - 1) * this.currentPerPage : 1;
      var last = Math.min(this.total, this.currentPerPage * this.currentPage);
      return first + ' - ' + last + ' ' + this.ofText + ' ' + this.total;
    },
    nextIsPossible: function nextIsPossible() {
      return this.total > this.currentPerPage * this.currentPage;
    },
    prevIsPossible: function prevIsPossible() {
      return this.currentPage > 1;
    }
  },

  mounted: function mounted() {
    if (this.perPage) {
      this.currentPerPage = this.perPage;
    }
  }
});

/***/ }),

/***/ "bJBA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView',{attrs:{"model":_vm.model}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bsFJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_record_form_vue__ = __webpack_require__("kydm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b8f44d5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_record_form_vue__ = __webpack_require__("IqxW");
function injectStyle (ssrContext) {
  __webpack_require__("nqcK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_record_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b8f44d5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_record_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cnQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView',{attrs:{"model":_vm.model}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dQYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Project Module Getters
var getters = {
  collection: function collection(state) {
    return state.collection;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "drpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("EMWT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__("TRCR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__("PGNy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("TlFM");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]

  // Add this to /src/store/index:
  // import google_sheet from './google_sheet'

});

/***/ }),

/***/ "e4Bl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__ = __webpack_require__("iJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'application_show',
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Applications - Show'
  },
  props: ['id'],
  created: function created() {
    return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('application/current', { app_id: this.id });
  },

  computed: {
    model: function model() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['application/current'];
    }
  }
});

/***/ }),

/***/ "eD4o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('a',{attrs:{"href":"#/applications"}},[_vm._v("Back")]),_vm._v(" "),_c('h2',[_vm._v("Application - New")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Application Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Name"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n        Google Sheets ID\n\n      ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("ID of the Google Sheet used to build the application.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.google_sheets_id),expression:"model.google_sheets_id"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Google Sheets ID"},domProps:{"value":(_vm.model.google_sheets_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "google_sheets_id", $event.target.value)}}})]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("\n        Name\n        "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Create")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fcFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__("qRo1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),

/***/ "fmIs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("aZ34");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f493048_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("XpA9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f493048_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h0gN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-striped table-hover"},[_c('thead',[_vm._l((_vm.schema.attributes),function(attr){return (attr.datatype !=='HAS_MANY' && attr.datatype !=='HAS_ONE' && attr.identifier !== _vm.ignoreAttribute)?_c('th',{key:attr._id},[_vm._v("\n      "+_vm._s(attr.label)+"\n      "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],staticClass:"fa fa-fw fa-question-circle-o",attrs:{"title":attr.help}})]):_vm._e()}),_vm._v(" "),(!_vm.disableControls)?_c('th'):_vm._e()],2),_vm._v(" "),_c('tbody',[_vm._l((_vm.records),function(record){return _c('tr',{key:record._id},[_vm._l((_vm.schema.attributes),function(attr){return (attr.datatype !== 'HAS_MANY' && attr.datatype !=='HAS_ONE' && attr.identifier !== _vm.ignoreAttribute)?_c('td',{key:attr._id},[(attr.datatype === 'BELONGS_TO')?_c('a',{attrs:{"href":_vm.getLinkedSchemaHref(attr, record.attributes[attr.identifier])}},[_vm._v("\n          "+_vm._s(_vm.getLinkedSchemaLabel(attr, record.attributes[attr.identifier]))+"\n        ")]):(attr.unique)?_c('a',{attrs:{"href":'#/schemas/' + _vm.schema._id + '/records/' + record._id}},[_vm._v("\n          "+_vm._s(record.attributes[attr.identifier])+"\n        ")]):(attr.datatype === 'BOOL')?_c('span',[(record.attributes[attr.identifier])?_c('i',{staticClass:"fa fa-fw fa-check-square-o"}):_vm._e(),_vm._v(" "),(!record.attributes[attr.identifier])?_c('i',{staticClass:"fa fa-fw fa-square-o"}):_vm._e()]):(attr.datatype === 'COLOR')?_c('span',[_c('i',{staticClass:"fa fa-fw fa-lg fa-square",style:('color:' + record.attributes[attr.identifier])})]):_c('span',[_vm._v("\n          "+_vm._s(record.attributes[attr.identifier] || attr.datatypeOptions.default)+"\n        ")])]):_vm._e()}),_vm._v(" "),(!_vm.disableControls)?_c('td',{staticClass:"text-right controls"},[_c('a',{staticClass:"btn btn-sm btn-outline-warning",attrs:{"href":'#/schemas/' + _vm.schema._id + '/records/' + record._id + '/edit'}},[_c('i',{staticClass:"fa fa-fw fa-pencil"})]),_vm._v(" "),_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('modal_' + record._id),expression:"'modal_' + record._id"}],staticClass:"btn btn-sm btn-outline-danger"},[_c('i',{staticClass:"fa fa-fw fa-trash"})]),_vm._v(" "),_c('b-modal',{attrs:{"id":'modal_' + record._id,"title":'Destroy ' + _vm.schema.label + '?',"header-bg-variant":"dark","header-text-variant":"light","body-bg-variant":"dark","body-text-variant":"light","footer-bg-variant":"danger","footer-text-variant":"light","ok-variant":"danger","ok-title":"DESTROY","cancel-title":"Cancel","cancel-variant":"dark"},on:{"ok":function($event){_vm.onConfirmDestroy(record)}}},[_c('p',{staticClass:"text-left"},[_vm._v("Are you sure you want to destroy this "+_vm._s(_vm.schema.label)+"?")])])],1):_vm._e()],2)}),_vm._v(" "),(!_vm.records.length)?_c('tr',_vm._l((_vm.schema.attributes),function(attr,i){return _c('td',[(i === 0)?_c('span',[_c('span',{staticClass:"text-warning mr-2"},[_vm._v("No records found.")]),_vm._v(" "),_c('span',{},[_vm._v("Click")]),_vm._v(" "),_c('a',{attrs:{"href":'#/schemas/' + _vm.schema._id + '/records/new'}},[_vm._v(" here ")]),_vm._v("\n          to create "+_vm._s(_vm.schema.label_plural.toLowerCase())+".\n        ")]):_vm._e()])})):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hQJW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),(_vm.required)?_c('span',{staticClass:"text-danger"},[_vm._v("*")]):_vm._e()]),_vm._v(" "),(_vm.example && _vm.help)?_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm.example)),_c('br'),_vm._v(_vm._s(_vm.help))]):(_vm.help)?_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm.help))]):_vm._e(),_vm._v(" "),(_vm.type === 'BOOL')?_c('input',{ref:"input_el",staticClass:"form-control",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){_vm.updateModel()}}}):(_vm.type === 'DATE')?_c('input',{ref:"input_el",staticClass:"form-control",attrs:{"type":"date","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){_vm.updateModel()}}}):(_vm.type === 'TIME')?_c('input',{ref:"input_el",staticClass:"form-control",attrs:{"type":"time","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){_vm.updateModel()}}}):_c('input',{ref:"input_el",staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){_vm.updateModel()}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iFVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Navbar')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iJx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("wEUI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4165cc7b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("48Rt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4165cc7b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ibQm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("Wo2i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f79cb644_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("RxIX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f79cb644_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ivcD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("9haB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e556b6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("EVI3");
function injectStyle (ssrContext) {
  __webpack_require__("tigD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e556b6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ix+C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

// import { TEXT_WORKFLOW_STEP, MACRO_WORKFLOW_STEP, DELAY_WORKFLOW_STEP, KEY_WORKFLOW_STEP, KEY_DN_POSITION, KEY_UP_POSITION, KEY_PR_POSITION } from './constants'

// // // //

// Project Module mutations
var mutations = {
  sync: function sync(state, collection) {
    state.collection = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(collection, function (s) {
      return s.order;
    });
  },
  persist: function persist(state, _ref) {
    var schema = _ref.schema;

    if (schema._id) {
      state.collection = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(state.collection, function (s) {
        if (s._id === schema._id) {
          return schema;
        } else {
          return s;
        }
      });
    } else {
      schema._id = 'schema_' + Math.floor(Math.random() * 100000000000000 + 1);
      state.collection.push(schema);
    }
    // Updates attributes order
    schema.attributes = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(schema.attributes, ['order'], ['asc']);
    state.selectedSchema = null;
  },
  destroy: function destroy(state, _ref2) {
    var schema = _ref2.schema;

    state.collection = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(state.collection, function (s) {
      return s._id !== schema._id;
    });
  },
  selectAttribute: function selectAttribute(state, _ref3) {
    var attr = _ref3.attr;

    state.selectedAttribute = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(attr);
  },
  selectSchema: function selectSchema(state, _ref4) {
    var _id = _ref4._id;

    state.selectedSchema = _id;
  },
  clearSelectedSchema: function clearSelectedSchema(state) {
    state.selectedSchema = null;
  },
  clearSelectedAttribute: function clearSelectedAttribute(state) {
    state.selectedAttribute = null;
  },
  removeAttribute: function removeAttribute(state, _ref5) {
    var schema = _ref5.schema,
        attr = _ref5.attr;

    schema.attributes = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(schema.attributes, function (s) {
      return s._id !== attr._id;
    });
  },
  persistSelectedAttribute: function persistSelectedAttribute(state, _ref6) {
    var schema = _ref6.schema,
        attr = _ref6.attr;

    if (attr._id) {
      schema.attributes = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(schema.attributes, function (a) {
        // QUESTION - just .map()
        if (a._id === attr._id) {
          return attr;
        } else {
          return a;
        }
      });
    } else {
      attr._id = 'attr_' + Math.floor(Math.random() * 100000000000000 + 1);
      if (attr.datatype !== 'TEXT_SELECT' && attr.datatype !== 'NUMBER_SELECT') {
        delete attr.datatypeOptions.dropdownOptions;
      }
      schema.attributes.push(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(attr));
    }

    // QUESTION - add REVERSE RELATION?
    // if (attr.datatype === 'BELONGS_TO') {
    //   let relatedSchema = _.find(state.collection, { _id: attr.datatypeOptions.schema_id })
    //   let relatedAttr = _.filter(relatedSchema.attributes, (a) => { return a.datatype === 'HAS_MANY' && a.datatypeOptions.schema_id === schema._id })
    //   console.log(relatedAttr)
    // }

    // Clears the selectedAttribute
    state.selectedAttribute = null;
  },
  addAttribute: function addAttribute(state, _ref7) {
    var schema = _ref7.schema;

    var new_attribute = {
      order: schema.attributes.length + 1,
      label: '',
      help: '',
      required: false,
      unique: false,
      col_span: 6,
      datatype: 'TEXT',
      datatypeOptions: {}
    };

    state.selectedAttribute = new_attribute;
  }
};

// // // //

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "ix0u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSubmit_vue__ = __webpack_require__("QERL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e833b04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSubmit_vue__ = __webpack_require__("x+ja");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSubmit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e833b04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSubmit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jE1R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("GJjZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd7546ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("FbWj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd7546ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jW3l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("KE38");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a4c664f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("aUdD");
function injectStyle (ssrContext) {
  __webpack_require__("zOG6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a4c664f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a4c664f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kJiG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__("9NuQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),

/***/ "kSTY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("VlU1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86ea443a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("4n4Y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86ea443a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kTc3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "knEz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-footer clearfix"},[_c('div',{staticClass:"datatable-length pull-left"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.rowsPerPageText))]),_vm._v(" "),_c('select',{staticClass:"browser-default",on:{"change":_vm.perPageChanged}},[(_vm.perPage)?_c('option',{domProps:{"value":_vm.perPage}},[_vm._v(_vm._s(_vm.perPage))]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v(_vm._s(_vm.allText))])])])]),_vm._v(" "),_c('div',{staticClass:"pagination-controls pull-right"},[_c('a',{staticClass:"page-btn",class:{ disabled: !_vm.prevIsPossible },attrs:{"href":"javascript:undefined","tabindex":"0"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.previousPage($event)}}},[_c('span',{staticClass:"chevron",class:{ 'left': !_vm.rtl, 'right': _vm.rtl }}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.prevText))])]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.paginatedInfo))]),_vm._v(" "),_c('a',{staticClass:"page-btn",class:{ disabled: !_vm.nextIsPossible },attrs:{"href":"javascript:undefined","tabindex":"0"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.nextPage($event)}}},[_c('span',[_vm._v(_vm._s(_vm.nextText))]),_vm._v(" "),_c('span',{staticClass:"chevron",class:{ 'right': !_vm.rtl, 'left': _vm.rtl }})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kt2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__ = __webpack_require__("xRBe");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app_navbar',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "kydm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_masked_input__ = __webpack_require__("4q2C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['schema', 'record', 'relatedAttr', 'persistRecord', 'cancelForm'],
  components: {
    MaskedInput: __WEBPACK_IMPORTED_MODULE_2_vue_masked_input__["a" /* default */],
    vSelect: __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a
  },
  methods: {
    getColspanCss: function getColspanCss(attr) {
      if (!attr.col_span) {
        return 'col-lg-12';
      } else {
        return 'col-lg-' + attr.col_span;
      }
    },
    schemaDropdown: function schemaDropdown(schema_id) {
      var allRecords = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['record/collection'];
      var dropdownRecords = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(allRecords, function (r) {
        return r.schema_id === schema_id;
      });
      return dropdownRecords;
    },

    // NOTE - this function is currently unused
    schemaDropdownVselect: function schemaDropdownVselect(schema_id, label_identifier) {
      var allRecords = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['record/collection'];
      var dropdownRecords = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(allRecords, function (r) {
        return r.schema_id === schema_id;
      });

      // Builds { value: 'user_123b3asd...', label: 'Username' } for Select2 dropdown
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(dropdownRecords, function (r) {
        return { value: r._id, label: r.attributes[label_identifier] };
      });
    }
  }
});

/***/ }),

/***/ "kzQ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Ki2S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5512817e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("GCRm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5512817e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l5BX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_vue__ = __webpack_require__("4QAh");
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_2__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Schema - New Record' // title is now "HotSheets - Schema - New Record"
  },
  props: ['id', 'record_id'],
  computed: {
    data: function data() {
      var allSchemas = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
      var schema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allSchemas, { _id: this.id });

      var allRecords = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['record/collection'];
      var record = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allRecords, { _id: this.record_id });

      return { schema: schema, record: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(record) };
    }
  }
});

/***/ }),

/***/ "lxpf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['item', 'remove', 'edit'],
  computed: {
    className: function className() {
      var css = ['list-group-item'];

      if (this.item.type === 'KEY_DOWN') {
        // css.push('list-group-item-primary')
        css.push('list-group-item-success');
        // css.push('list-group-item-dark')
      } else if (this.item.type === 'KEY_UP') {
        // css.push('list-group-item-success')
        css.push('list-group-item-warning');
        css.push('draggable');
      } else if (this.item.type === 'FINISH') {
        css.push('list-group-item-dark');
      } else {
        css.push('bg-dark text-light');
        css.push('draggable');
      }

      return css.join(' ');
    },
    removable: function removable() {
      return true;
    }
  }
});

/***/ }),

/***/ "ml2g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Application Module State
var state = {
  collection: [],
  current: {},
  fetching: false
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ "mpQj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['model']
});

/***/ }),

/***/ "mxBa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notificationChild_vue__ = __webpack_require__("ZHbe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_686928f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notificationChild_vue__ = __webpack_require__("6QGx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notificationChild_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_686928f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notificationChild_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nHb0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nqcK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o3Oz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Application Module Getters
var getters = {
  collection: function collection(state) {
    return state.collection;
  },
  current: function current(state) {
    return state.current;
  },
  fetching: function fetching(state) {
    return state.fetching;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "oLr1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['type', 'value'],
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },
  data: function data() {
    var data = {
      editing: null,
      myArray: this.buildArray()
    };
    return data;
  },

  methods: {
    buildArray: function buildArray() {
      if (this.value && Array.isArray(this.value)) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.value, function (v, i) {
          return { id: i + 1, value: v };
        });
      } else if (this.type === 'TEXT_SELECT') {
        return [{ id: 1, value: 'Option 1' }, { id: 2, value: 'Option 2' }];
      } else {
        return [{ id: 1, value: 1000 }, { id: 2, value: 2000 }];
      }
    },
    cancelEditing: function cancelEditing(editing) {
      this.editing = null;
    },
    submitEditing: function submitEditing(editing) {
      if (editing.id) {
        this.myArray = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.myArray, function (el) {
          if (editing.id === el.id) {
            return editing;
          } else {
            return el;
          }
        });
      } else {
        editing.id = this.myArray.length + 1;
        this.myArray.push(editing);
      }
      // Clears the editing flag
      this.editing = null;
      this.updateValue();
    },
    addOption: function addOption() {
      this.editing = { id: null, value: '' };
    },
    editOption: function editOption(element) {
      this.editing = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(element);
    },
    destroyOption: function destroyOption(element) {
      this.myArray = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.myArray, function (el) {
        return el.id !== element.id;
      });
      this.updateValue();
    },
    updateValue: function updateValue() {
      this.$emit('input', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.myArray, function (el) {
        return el.value;
      }));
    }
  },
  computed: {
    sortableOptions: function sortableOptions() {
      return {
        animation: 150,
        handle: '.drag-handle',
        ghostClass: 'ghost', // Class name for the drop placeholder
        chosenClass: 'chosen', // Class name for the chosen item
        dragClass: 'drag', // Class name for the dragging item
        fallbackTolerance: 100
      };
    },

    dropdownOptions: {
      get: function get() {
        return this.myArray;
      },
      set: function set(value) {
        this.myArray = value;
        this.updateValue();
      }
    }
  }
});

/***/ }),

/***/ "oQdh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("ttCC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8740a214_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("TkMW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8740a214_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oeT9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__ = __webpack_require__("Ua4y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'application_edit',
  components: {
    LayoutView: __WEBPACK_IMPORTED_MODULE_0__components_layout_vue__["a" /* default */]
  },
  metaInfo: {
    title: 'Applications - Edit' // title is now "TITLE - Application - Edit"
  },
  props: ['id'],
  created: function created() {
    return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('application/current', { app_id: this.id });
  },

  computed: {
    model: function model() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['application/current'];
    }
  }
});

/***/ }),

/***/ "pWOW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__list_vue__ = __webpack_require__("RL/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collection'],
  computed: {
    fetching: function fetching() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['application/fetching'];
    }
  },
  components: {
    ListView: __WEBPACK_IMPORTED_MODULE_0__list_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "qZEt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routers__ = __webpack_require__("Q3uA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__record_new_components_record_form_vue__ = __webpack_require__("bsFJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['schema', 'record'],
  components: {
    RecordForm: __WEBPACK_IMPORTED_MODULE_2__record_new_components_record_form_vue__["a" /* default */]
  },
  methods: {
    persistRecord: function persistRecord(schema, record) {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('record/persist', { schema: schema, record: record, redirect: true });
    },
    cancelForm: function cancelForm() {
      __WEBPACK_IMPORTED_MODULE_1__routers__["a" /* default */].go(-1);
    }
  }
});

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("xKc6");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("X7DP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rIoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Schema Module State
var state = {
  collection: [{
    label: 'Contact',
    identifier: 'contact',
    _id: 'schema_29321443037762',
    unqiue_id_prefix: 'CT_',
    display: {
      navbar_link: true,
      icon: 'fa-user-circle-o'
    },
    attributes: [{
      order: 0,
      label: 'Name',
      help: 'Name of the individual',
      required: false,
      datatype: 'TEXT',
      datatypeOptions: {},
      identifier: 'name',
      unique: true,
      _id: 'attr_1',
      preferred: true,
      col_span: '4'
    }, {
      order: 2,
      label: 'Phone Number',
      help: 'Phone number of the individual',
      required: false,
      datatype: 'PHONE_NUMBER',
      datatypeOptions: {},
      identifier: 'phone',
      _id: 'attr_3',
      col_span: '4'
    }, {
      order: 3,
      label: 'E-Mail',
      help: 'E-Mail address associated with this Contact.',
      required: true,
      unique: false,
      preferred: false,
      col_span: '4',
      datatype: 'TEXT',
      datatypeOptions: {},
      identifier: 'email',
      _id: 'attr_26577092992831'
    }, {
      order: 4,
      label: 'Address',
      help: 'Address for this contact',
      required: false,
      unique: false,
      preferred: false,
      col_span: 12,
      datatype: 'HAS_ONE',
      datatypeOptions: {
        schema_id: 'schema_14808974981067'
      },
      identifier: 'address_id',
      _id: 'attr_63003613597957'
    }, {
      order: 5,
      label: 'Invoices',
      help: 'Invoices associated with this person',
      required: false,
      unique: false,
      preferred: false,
      col_span: 12,
      datatype: 'HAS_MANY',
      datatypeOptions: {
        schema_id: 'schema_22881179555990'
      },
      identifier: 'invoice_ids',
      _id: 'attr_37727300204170'
    }, {
      order: 7,
      label: 'Jobs',
      help: 'Jobs worked',
      required: false,
      unique: false,
      preferred: false,
      col_span: 12,
      datatype: 'HAS_MANY',
      datatypeOptions: {
        schema_id: 'schema_85414304137721'
      },
      identifier: 'job_ids',
      _id: 'attr_63065825981008'
    }],
    label_plural: 'Contacts',
    identifier_plural: 'contacts'
  }, {
    label: 'Invoice',
    identifier: 'invoice',
    _id: 'schema_22881179555990',
    unqiue_id_prefix: 'IV_',
    display: {
      navbar_link: true,
      icon: 'fa-usd'
    },
    attributes: [{
      order: 0,
      label: 'Invoice ID',
      help: 'Unique Invoice ID',
      required: true,
      datatype: 'TEXT',
      datatypeOptions: {},
      identifier: 'invoice_id',
      unique: true,
      col_span: '6',
      _id: 'attr_5'
    }, {
      order: 1,
      label: 'Contact',
      help: 'Contact to whom the invoice has been sent.',
      required: true,
      datatype: 'BELONGS_TO',
      datatypeOptions: {
        schema_id: 'schema_29321443037762',
        schema_attribute_identifier: 'name'
      },
      identifier: 'contact_id',
      col_span: '6',
      _id: 'attr_1'
    }, {
      order: 2,
      label: 'Amount',
      help: 'The amount of USD for the invoice',
      required: true,
      datatype: 'NUMBER',
      datatypeOptions: {},
      identifier: 'amount',
      col_span: '4',
      _id: 'attr_2'
    }, {
      order: 3,
      label: 'Date',
      help: 'Date the invoice was sent out.',
      required: true,
      datatype: 'DATE',
      datatypeOptions: {},
      identifier: 'date',
      col_span: '4',
      _id: 'attr_4'
    }, {
      order: 4,
      label: 'Payment Received',
      help: 'Indicates whether or not payment has been received.',
      required: false,
      datatype: 'BOOL',
      datatypeOptions: {},
      identifier: 'payment_received',
      col_span: '4',
      _id: 'attr_3'
    }],
    label_plural: 'Invoices',
    identifier_plural: 'invoice'
  }, {
    label: 'Job',
    identifier: 'job',
    _id: 'schema_85414304137721',
    unqiue_id_prefix: 'JB_',
    display: {
      navbar_link: true,
      icon: 'fa-list-alt'
    },
    attributes: [{
      order: 1,
      label: 'Job ID',
      help: 'Unique ID',
      required: true,
      datatype: 'TEXT',
      datatypeOptions: {},
      identifier: 'job_id',
      unique: true,
      col_span: 6,
      _id: 'attr_1'
    }, {
      order: 2,
      label: 'Contact',
      help: 'Contact for whom the Job is being done',
      required: true,
      datatype: 'BELONGS_TO',
      datatypeOptions: {
        schema_id: 'schema_29321443037762',
        schema_attribute_identifier: 'name'
      },
      identifier: 'contact_id',
      col_span: 6,
      _id: 'attr_2'
    }, {
      order: 3,
      label: 'Invoice',
      help: 'Invoice for this Job',
      required: false,
      datatype: 'BELONGS_TO',
      datatypeOptions: {
        schema_id: 'schema_22881179555990',
        schema_attribute_identifier: 'invoice_id'
      },
      identifier: 'invoice_id',
      col_span: 6,
      _id: 'attr_3'
    }, {
      order: 4,
      label: 'Status',
      help: 'Status of the Job',
      required: false,
      datatype: 'TEXT',
      datatypeOptions: {},
      identifier: 'status',
      col_span: 6,
      _id: 'attr_4'
    }],
    label_plural: 'Jobs',
    identifier_plural: 'jobs'
  }, {
    _id: 'schema_14808974981067',
    label: 'Address',
    label_plural: 'Addresses',
    identifier: 'address',
    identifier_plural: 'addresses',
    attributes: [{
      order: 1,
      label: 'Street Address',
      help: 'Street Address (i.e. 123 Main St.)',
      required: true,
      unique: false,
      col_span: 6,
      datatype: 'TEXT',
      datatypeOptions: {},
      identifier: 'street_address',
      _id: 'attr_72437938398278'
    }, {
      order: 2,
      label: 'Street Address 2',
      help: 'Apartment or Suite # (i.e. Apt. 1)',
      required: false,
      unique: false,
      col_span: 6,
      datatype: 'TEXT',
      datatypeOptions: {},
      identifier: 'street_address_two',
      _id: 'attr_79838196774464'
    }, {
      order: 3,
      label: 'City',
      help: 'City the address resides in',
      required: true,
      unique: false,
      col_span: '4',
      datatype: 'TEXT',
      datatypeOptions: {},
      identifier: 'city',
      _id: 'attr_28081761172432'
    }, {
      order: 4,
      label: 'State',
      help: 'State the city resides in',
      required: true,
      unique: false,
      col_span: '4',
      datatype: 'TEXT_SELECT',
      datatypeOptions: {
        dropdownOptions: ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District Of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming']
      },
      identifier: 'state',
      _id: 'attr_27558409417743'
    }, {
      order: 5,
      label: 'Zip Code',
      help: 'Zip Code of the address',
      required: true,
      unique: false,
      col_span: '4',
      datatype: 'NUMBER',
      datatypeOptions: {},
      identifier: 'zip_code',
      _id: 'attr_53043500828843'
    }],
    display: {
      icon: 'fa-home',
      navbar_link: false
    },
    unqiue_id_prefix: 'AD_'
  }],
  selectedAttribute: null
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ "rrPM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s1DK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routers__ = __webpack_require__("Q3uA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__record_form_vue__ = __webpack_require__("bsFJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['schema', 'record'],
  components: {
    RecordForm: __WEBPACK_IMPORTED_MODULE_2__record_form_vue__["a" /* default */]
  },
  methods: {
    persistRecord: function persistRecord(schema, record) {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('record/persist', { schema: schema, record: record, redirect: true });
    },
    cancelForm: function cancelForm() {
      __WEBPACK_IMPORTED_MODULE_1__routers__["a" /* default */].go(-1);
    }
  }
});

/***/ }),

/***/ "sRpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Project Module Getters
var getters = {
  collection: function collection(state) {
    return state.collection;
  },
  current: function current(state) {
    return state.current;
  },
  fetching: function fetching(state) {
    return state.fetching;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "scBT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "skhC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");





// AbstractFactory class definition

var AbstractFactory = function () {
  // constructor
  function AbstractFactory(options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AbstractFactory);

    this.options = options;
    this.messages = options.messages; // TODO - support default messages
    this.API_ROOT = options.API_ROOT;
    return this;
  }

  // fetchCollection


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AbstractFactory, [{
    key: 'fetchCollection',
    value: function fetchCollection(_ref) {
      var commit = _ref.commit;

      // State.fetching = true
      commit('fetching', true);

      // Fetches Collection from the server
      fetch(this.API_ROOT)
      // Parses response into JSON
      .then(function (response) {
        return response.json();
      }).then(function (json) {
        // State.fetching = false
        commit('fetching', false);

        // Sets state.collection
        commit('sync', json.items);
      }); // TODO - CATCH statement
    }

    // fetchModel

  }, {
    key: 'fetchModel',
    value: function fetchModel(_ref2, id) {
      var commit = _ref2.commit;

      // State.fetching = true
      commit('fetching', true);

      // Fetches Collection from the server
      fetch(this.API_ROOT + '/' + id)
      // Parses response into JSON
      .then(function (response) {
        return response.json();
      }).then(function (json) {
        // State.fetching = false
        commit('fetching', false);

        // Sets state.current
        // TODO - rethink this approach..
        commit('current', json);
      }); // TODO - CATCH statement
    }

    // create

  }, {
    key: 'create',
    value: function create(_ref3, attributes) {
      var _this = this;

      var commit = _ref3.commit;

      // POST /API_ROOT
      fetch(this.API_ROOT, {
        method: 'post',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(attributes),
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      })
      // Parses response into JSON
      .then(function (response) {
        return response.json();
      }).then(function (json) {
        // TODO - ADD ITEM TO COLLECTION

        // Shows CREATE_SUCCESS message
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('notification/add', { message: _this.messages.CREATE_SUCCESS, context: 'info', dismissible: true });

        // Redirects to REDIRECT_SUCCESS
        // TODO - What is the best way to manage redirection in VueJS?
        window.location = _this.options.REDIRECT_SUCCESS;
      }); // TODO - CATCH statement
    }

    // update

  }, {
    key: 'update',
    value: function update(_ref4, attributes) {
      var _this2 = this;

      var commit = _ref4.commit;

      return fetch(this.API_ROOT + '/' + attributes._id, {
        method: 'put',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(attributes),
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      }).then(function (response) {
        // Shows UPDATE_SUCCESS message
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('notification/add', { message: _this2.messages.UPDATE_SUCCESS, context: 'success', dismissible: true });

        // Redirects to REDIRECT_SUCCESS
        // TODO - What is the best way to manage redirection in VueJS?
        window.location = _this2.options.REDIRECT_SUCCESS;
      }); // TODO - CATCH STATEMENT
    }

    // destroy

  }, {
    key: 'destroy',
    value: function destroy(_ref5, id) {
      var _this3 = this;

      var commit = _ref5.commit;

      return fetch(this.API_ROOT + '/' + id, {
        method: 'delete'
      }).then(function (response) {
        // TODO - REMOVE ITEM FROM COLLECTION

        // Shows DESTROY_SUCCESS message
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('notification/add', { message: _this3.messages.DESTROY_SUCCESS, context: 'success', dismissible: true });

        // Redirects to REDIRECT_SUCCESS
        // TODO - What is the best way to manage redirection in VueJS?
        window.location = _this3.options.REDIRECT_SUCCESS;
      }); // TODO - CATCH STATEMENT
    }
  }]);

  return AbstractFactory;
}();
// // // //

/* harmony default export */ __webpack_exports__["a"] = (AbstractFactory);

/***/ }),

/***/ "spmD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_RecordTable__ = __webpack_require__("/wTD");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['schema', 'records'],
  components: {
    RecordTable: __WEBPACK_IMPORTED_MODULE_0__components_RecordTable__["a" /* default */]
  }
});

/***/ }),

/***/ "t/gG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8"},[_c('h2',[(_vm.schema.display.icon)?_c('i',{class:'fa fa-fw ' + _vm.schema.display.icon}):_vm._e(),_vm._v("\n        "+_vm._s(_vm.schema.label_plural)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 text-right"},[_c('a',{staticClass:"btn btn-outline-warning",attrs:{"href":'#/schemas/' + _vm.schema._id + '/edit'}},[_c('i',{staticClass:"fa fa-fw fa-pencil"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-outline-success",attrs:{"href":'#/schemas/' + _vm.schema._id + '/records/new'}},[_c('i',{staticClass:"fa fa-fw fa-plus mr-2"}),_vm._v("\n        New "+_vm._s(_vm.schema.label)+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('RecordTable',{attrs:{"schema":_vm.schema,"records":_vm.records}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t4xi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tBuJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REGISTER_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTHENTICATE_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SESSION_ROUTE; });
var REGISTER_ROUTE = '/api/auth/register';
var AUTHENTICATE_ROUTE = '/api/auth/login';
var SESSION_ROUTE = '/api/profile';

/***/ }),

/***/ "tQY2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"container",attrs:{"name":"list","tag":"div"}},_vm._l((_vm.collection),function(each){return _c('div',{key:each.id,staticClass:"row"},[_c('NotificationChild',{attrs:{"item":each}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tigD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tjOf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("QVUP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_150c2c7f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Xrce");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_150c2c7f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ttCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormInput__ = __webpack_require__("O9rZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormSubmit__ = __webpack_require__("ix0u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import auth from '../../../services/auth.js'




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: 'alex@foo.bar',
      password: 'abc123abc123',
      remember: false,
      loading: false,
      error: false
    };
  },


  components: {
    FormInput: __WEBPACK_IMPORTED_MODULE_0__components_FormInput__["a" /* default */],
    FormSubmit: __WEBPACK_IMPORTED_MODULE_1__components_FormSubmit__["a" /* default */]
  },

  methods: {
    authenticate: function authenticate() {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/googleAuthenticate');
    }
  }
});

/***/ }),

/***/ "u5nZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(!_vm.editing)?_c('div',{staticClass:"col-lg-12"},[_c('draggable',{staticClass:"list-group",attrs:{"options":_vm.sortableOptions,"element":"ul"},model:{value:(_vm.dropdownOptions),callback:function ($$v) {_vm.dropdownOptions=$$v},expression:"dropdownOptions"}},_vm._l((_vm.dropdownOptions),function(element){return _c('li',{key:element.id,staticClass:"list-group-item border-light bg-dark text-light"},[_c('div',{staticClass:"row d-flex align-items-center"},[_c('div',{staticClass:"col-lg-2"},[_c('i',{staticClass:"fa fa-fw fa-bars drag-handle"})]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_vm._v("\n              "+_vm._s(element.value)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 text-right"},[_c('button',{staticClass:"btn btn-sm btn-outline-warning",on:{"click":function($event){_vm.editOption(element)}}},[_c('i',{staticClass:"fa fa-fw fa-pencil"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-danger",on:{"click":function($event){_vm.destroyOption(element)}}},[_c('i',{staticClass:"fa fa-fw fa-trash"})])])])])})),_vm._v(" "),_c('button',{staticClass:"btn btn btn-outline-success btn-block mt-4",on:{"click":function($event){_vm.addOption()}}},[_c('i',{staticClass:"fa fa-fw fa-plus mr-2"}),_vm._v("\n      Dropdown Option\n    ")])],1):_vm._e(),_vm._v(" "),(_vm.editing)?_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card card-body border-light bg-dark text-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[(_vm.editing.id)?_c('p',{staticClass:"lead mb-0"},[_vm._v("Edit Dropdown Option")]):_c('p',{staticClass:"lead mb-0"},[_vm._v("New Dropdown Option")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 text-right"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",on:{"click":function($event){_vm.cancelEditing(_vm.editing)}}},[_c('i',{staticClass:"fa fa-fw fa-times mr-1"}),_vm._v("\n              Cancel\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-success",on:{"click":function($event){_vm.submitEditing(_vm.editing)}}},[_c('i',{staticClass:"fa fa-fw fa-check mr-1"}),_vm._v("\n              Submit\n            ")])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[(_vm.type === 'TEXT_SELECT')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editing.value),expression:"editing.value"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Dropdown Value"},domProps:{"value":(_vm.editing.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editing, "value", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.type === 'NUMBER_SELECT')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editing.value),expression:"editing.value"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Dropdown Value"},domProps:{"value":(_vm.editing.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editing, "value", $event.target.value)}}}):_vm._e()])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v+OF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutView',{attrs:{"collection":_vm.collection}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v9+0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-body bg-dark text-light border-light"},[(_vm.selectedAttr)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-4 text-right"},[(_vm.selectedAttr)?_c('div',{staticClass:"btn-group w-100"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary w-50",on:{"click":function($event){_vm.clearSelected()}}},[_c('i',{staticClass:"fa fa-fw mr-1 fa-angle-left"}),_vm._v("\n              Back\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-success w-50",on:{"click":function($event){_vm.updateSelected(_vm.selectedAttr)}}},[_c('i',{staticClass:"fa fa-fw mr-1 fa-check"}),_vm._v("\n              Submit\n            ")])]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAttr.label),expression:"selectedAttr.label"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Label"},domProps:{"value":(_vm.selectedAttr.label)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedAttr, "label", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAttr.identifier),expression:"selectedAttr.identifier"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Identifier"},domProps:{"value":(_vm.selectedAttr.identifier)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedAttr, "identifier", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("The text provided to an end-user to aid in their understanding of this attribute (this text here).")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAttr.help),expression:"selectedAttr.help"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Help"},domProps:{"value":(_vm.selectedAttr.help)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedAttr, "help", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('div',{staticClass:"form-group"},[_vm._m(7),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Whether or not this attribute is required.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAttr.required),expression:"selectedAttr.required"}],staticClass:"form-control",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedAttr.required)?_vm._i(_vm.selectedAttr.required,null)>-1:(_vm.selectedAttr.required)},on:{"change":function($event){var $$a=_vm.selectedAttr.required,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedAttr.required=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedAttr.required=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.selectedAttr, "required", $$c)}}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Unique")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Whether or not to enforce unique values for this attribute.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAttr.unique),expression:"selectedAttr.unique"}],staticClass:"form-control",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedAttr.unique)?_vm._i(_vm.selectedAttr.unique,null)>-1:(_vm.selectedAttr.unique)},on:{"change":function($event){var $$a=_vm.selectedAttr.unique,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedAttr.unique=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedAttr.unique=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.selectedAttr, "unique", $$c)}}}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"lead mb-0"},[_vm._v("DataType")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("The type of data represented by this attribute.")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAttr.datatype),expression:"selectedAttr.datatype"}],staticClass:"form-control",attrs:{"placeholder":"Datatype"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedAttr, "datatype", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])]),_vm._v(" "),(_vm.selectedAttr.datatype === 'TEXT_SELECT' || _vm.selectedAttr.datatype === 'NUMBER_SELECT')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Dropdown Options")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Available options for this dropdown menu.")]),_vm._v(" "),_c('ArrayInput',{attrs:{"type":_vm.selectedAttr.datatype},model:{value:(_vm.selectedAttr.datatypeOptions.dropdownOptions),callback:function ($$v) {_vm.$set(_vm.selectedAttr.datatypeOptions, "dropdownOptions", $$v)},expression:"selectedAttr.datatypeOptions.dropdownOptions"}})],1):_vm._e(),_vm._v(" "),(_vm.selectedAttr.datatype === 'BELONGS_TO' || _vm.selectedAttr.datatype === 'HAS_ONE' || _vm.selectedAttr.datatype === 'HAS_MANY')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Related Schema")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("The Schema with which this attribute maintains a relation.")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAttr.datatypeOptions.schema_id),expression:"selectedAttr.datatypeOptions.schema_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedAttr.datatypeOptions, "schema_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.allSchemas),function(s){return (_vm.selectedAttr.datatype === 'BELONGS_TO')?_c('option',{key:s._id,domProps:{"value":s._id}},[_vm._v(_vm._s(s.label))]):_vm._e()}),_vm._v(" "),_vm._l((_vm.allSchemas),function(s){return (_vm.selectedAttr.datatype === 'HAS_ONE')?_c('option',{key:s._id,domProps:{"value":s._id}},[_vm._v(_vm._s(s.label))]):_vm._e()}),_vm._v(" "),_vm._l((_vm.allSchemas),function(s){return (_vm.selectedAttr.datatype === 'HAS_MANY')?_c('option',{key:s._id,domProps:{"value":s._id}},[_vm._v(_vm._s(s.label_plural))]):_vm._e()})],2)]):_vm._e(),_vm._v(" "),(_vm.selectedAttr.datatype === 'BELONGS_TO')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Related Schema Key")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("The name of the attribute on the related schema that is stored in this schema as a means of linking the two.")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAttr.datatypeOptions.schema_attribute_identifier),expression:"selectedAttr.datatypeOptions.schema_attribute_identifier"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedAttr.datatypeOptions, "schema_attribute_identifier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.schemaAttributes(_vm.selectedAttr.datatypeOptions.schema_id)),function(a){return _c('option',{key:a._id,domProps:{"value":a.identifier}},[_vm._v(_vm._s(a.label))])}))]):_vm._e(),_vm._v(" "),(_vm.selectedAttr.datatype === 'HAS_ONE')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Related Schema Key")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("The name of the attribute on the related schema that is stored in this schema as a means of linking the two.")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAttr.datatypeOptions.schema_attribute_identifier),expression:"selectedAttr.datatypeOptions.schema_attribute_identifier"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedAttr.datatypeOptions, "schema_attribute_identifier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.schemaAttributes(_vm.selectedAttr.datatypeOptions.schema_id)),function(a){return _c('option',{key:a._id,domProps:{"value":a.identifier}},[_vm._v(_vm._s(a.label))])}))]):_vm._e(),_vm._v(" "),(_vm.selectedAttr.datatype === 'NUMBER')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Default Value")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("The default value for this attribute when none is available.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAttr.datatypeOptions.default),expression:"selectedAttr.datatypeOptions.default"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Default Value"},domProps:{"value":(_vm.selectedAttr.datatypeOptions.default)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedAttr.datatypeOptions, "default", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.selectedAttr.datatype === 'TEXT')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Default Value")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("The default value for this attribute when none is available.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAttr.datatypeOptions.default),expression:"selectedAttr.datatypeOptions.default"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Default Value"},domProps:{"value":(_vm.selectedAttr.datatypeOptions.default)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedAttr.datatypeOptions, "default", $event.target.value)}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-12"},[_c('hr'),_vm._v(" "),_c('p',{staticClass:"lead mb-0"},[_vm._v("Display Options")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n          Input Column Span\n        ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("The column span of the input field when it appears in a form (2-12).")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAttr.col_span),expression:"selectedAttr.col_span"}],staticClass:"form-control",attrs:{"type":"number"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedAttr, "col_span", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"6"}},[_vm._v("Column Span (6 Default)")]),_vm._v(" "),_c('option',[_vm._v("2")]),_vm._v(" "),_c('option',[_vm._v("3")]),_vm._v(" "),_c('option',[_vm._v("4")]),_vm._v(" "),_c('option',[_vm._v("5")]),_vm._v(" "),_c('option',[_vm._v("6")]),_vm._v(" "),_c('option',[_vm._v("7")]),_vm._v(" "),_c('option',[_vm._v("8")]),_vm._v(" "),_c('option',[_vm._v("9")]),_vm._v(" "),_c('option',[_vm._v("10")]),_vm._v(" "),_c('option',[_vm._v("11")]),_vm._v(" "),_c('option',[_vm._v("12")])])])])]):_vm._e(),_vm._v(" "),(!_vm.selectedAttr)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Attributes")]),_vm._v(" "),_c('small',{staticClass:"mb-2 form-text text-muted"},[_vm._v("Defines the attributes that can be assigned to an entity of this schema.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('draggable',{staticClass:"list-group",attrs:{"options":_vm.sortableOptions},model:{value:(_vm.attributes),callback:function ($$v) {_vm.attributes=$$v},expression:"attributes"}},[_vm._l((_vm.attributes),function(each){return _c('AttributeItem',{key:each._id,attrs:{"item":each,"remove":_vm.removeAttribute,"edit":_vm.editAttribute}})}),_vm._v(" "),(!_vm.attributes.length)?_c('li',{staticClass:"px-2 py-4 text-center list-group-item list-group-item-info",on:{"click":function($event){_vm.addAttribute()}}},[_c('i',{staticClass:"fa fa-fw fa-plus mr-2"}),_vm._v(" "),_c('br'),_vm._v("\n          Click to add your first Attribute.\n        ")]):_vm._e()],2),_vm._v(" "),(!_vm.selectedAttr && _vm.attributes.length)?_c('div',{staticClass:"btn-group w-100 mt-3"},[_c('button',{staticClass:"btn btn-light w-100",on:{"click":function($event){_vm.addAttribute()}}},[_c('i',{staticClass:"fa fa-fw fa-plus mr-2"}),_vm._v("\n          Add Attribute\n        ")])]):_vm._e()],1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-8"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Attribute")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Define the core parameters that are used to create a valid Attribute.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12"},[_c('p',{staticClass:"lead mb-0"},[_vm._v("Properties")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("\n              Label\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"form-text text-muted"},[_vm._v("Example: 'Last Name'"),_c('br'),_vm._v("The human-readable name for this attribute.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("\n              Identifier\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"form-text text-muted"},[_vm._v("Example: 'last_name'"),_c('br'),_vm._v("Lowercase, no spaces.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("\n          Help Text\n          "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("\n              Required\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('optgroup',{attrs:{"label":"Basics"}},[_c('option',{attrs:{"value":"TEXT"}},[_vm._v("Text")]),_vm._v(" "),_c('option',{attrs:{"value":"NUMBER"}},[_vm._v("Number")]),_vm._v(" "),_c('option',{attrs:{"value":"BOOL"}},[_vm._v("Checkbox")]),_vm._v(" "),_c('option',{attrs:{"value":"DATE"}},[_vm._v("Date")]),_vm._v(" "),_c('option',{attrs:{"value":"TIME"}},[_vm._v("Time")]),_vm._v(" "),_c('option',{attrs:{"value":"COLOR"}},[_vm._v("Color")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('optgroup',{attrs:{"label":"Masked"}},[_c('option',{attrs:{"value":"PHONE_NUMBER"}},[_vm._v("Phone Number")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('optgroup',{attrs:{"label":"Dropdowns"}},[_c('option',{attrs:{"value":"TEXT_SELECT"}},[_vm._v("Text Dropdown")]),_vm._v(" "),_c('option',{attrs:{"value":"NUMBER_SELECT"}},[_vm._v("Number Dropdown")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('optgroup',{attrs:{"label":"Relations"}},[_c('option',{attrs:{"value":"HAS_ONE"}},[_vm._v("Has One")]),_vm._v(" "),_c('option',{attrs:{"value":"BELONGS_TO"}},[_vm._v("Belongs To")]),_vm._v(" "),_c('option',{attrs:{"value":"HAS_MANY"}},[_vm._v("Has Many")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vwq3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "w1je":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserListRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UserShowRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_user_list__ = __webpack_require__("W/Hi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_user_show__ = __webpack_require__("2kl+");
// User Containers



var UserListRoute = {
  path: '/users',
  component: __WEBPACK_IMPORTED_MODULE_0__containers_user_list__["a" /* default */]
};

var UserShowRoute = {
  path: '/users/:id',
  component: __WEBPACK_IMPORTED_MODULE_1__containers_user_show__["a" /* default */],
  props: true
};

/***/ }),

/***/ "wEUI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['model'],
  methods: {
    onConfirm: function onConfirm() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('application/destroy', { app: this.model });
    }
  }
});

/***/ }),

/***/ "wHjG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Footer')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x+ja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"btn btn-outline-success btn-block",attrs:{"type":"submit","value":"Login"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x/mD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("UQhV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c4a43e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("IOe2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c4a43e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_app_navbar__ = __webpack_require__("+5rB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_app_footer__ = __webpack_require__("FnWz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_app_notification__ = __webpack_require__("XazP");
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  // Top-Level Application Components
  components: {
    AppNavbar: __WEBPACK_IMPORTED_MODULE_0__containers_app_navbar__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_2__containers_app_notification__["a" /* default */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__containers_app_footer__["a" /* default */]
  },

  // Top-Level page Meta
  metaInfo: {
    title: 'Loading...', // set a title
    titleTemplate: 'HotSheets - %s', // title is now "HotSheets - Loading..."
    htmlAttrs: {
      lang: 'en'
    }
  }

});

/***/ }),

/***/ "xKc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__("E9Zr");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),

/***/ "xRBe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("OdUf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_062ffff3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("2OCT");
function injectStyle (ssrContext) {
  __webpack_require__("M/Ab")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_062ffff3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xYjX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-lg navbar-light bg-light"},[_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav mr-auto"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/"}},[_vm._v("RCOS 2017")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xcLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h2',[_vm._v("Edit "+_vm._s(_vm.schema.label))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('RecordForm',{attrs:{"schema":_vm.schema,"record":_vm.record,"persistRecord":_vm.persistRecord,"cancelForm":_vm.cancelForm}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yJZh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("NnBr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__("ml2g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__("o3Oz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("8+Rs");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]

  // Add this to /src/store/index:
  // import application from './application'

});

/***/ }),

/***/ "yaHL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Project Module State
var state = {
  collection: [],
  current: {},
  fetching: false
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ "z2OK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main_home',
  computed: {}
});

/***/ }),

/***/ "zOG6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zgiQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AttributeItem__ = __webpack_require__("PL+F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ArrayInput__ = __webpack_require__("/EPi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['schema'],
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a,
    AttributeItem: __WEBPACK_IMPORTED_MODULE_3__AttributeItem__["a" /* default */],
    ArrayInput: __WEBPACK_IMPORTED_MODULE_4__components_ArrayInput__["a" /* default */]
  },
  methods: {
    addAttribute: function addAttribute() {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('schema/addAttribute', { schema: this.schema });
    },
    removeAttribute: function removeAttribute(attr) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('schema/removeAttribute', { schema: this.schema, attr: attr });
    },
    editAttribute: function editAttribute(attr) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('schema/selectAttribute', { attr: attr });
    },
    clearSelected: function clearSelected() {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('schema/clearSelectedAttribute');
    },
    updateSelected: function updateSelected(attr) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('schema/persistSelectedAttribute', { schema: this.schema, attr: attr });
    },
    schemaAttributes: function schemaAttributes(schema_id) {
      if (!schema_id) return [{ label: 'Please Select A Schema' }];
      var allSchemas = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
      var schema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allSchemas, { _id: schema_id });
      if (!schema) return [{ label: 'Please Select A Schema' }];
      return schema.attributes;
    }
  },
  computed: {
    allSchemas: function allSchemas() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/collection'];
    },
    selectedAttr: function selectedAttr() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['schema/selectedAttribute'];
    },
    sortableOptions: function sortableOptions() {
      return {
        draggable: '.draggable',
        animation: 150,
        fallbackTolerance: 100
      };
    },

    attributes: {
      get: function get() {
        // TODO - this should be moved into Vuex store
        this.schema.attributes = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(this.schema.attributes, ['order'], ['asc']);
        return this.schema.attributes;
      },
      set: function set(value) {
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(value, function (s, i) {
          s.order = i;
        });
      }
    }
  }
});

/***/ }),

/***/ "zp1C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("pWOW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48beab84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("6yg/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48beab84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zzTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__factory__ = __webpack_require__("Ct8H");




// // // //

// actions
// functions that causes side effects and can involve asynchronous operations.
var actions = {

  authenticate: function authenticate(_ref, data) {
    var commit = _ref.commit;

    // State.fetching = true
    commit('fetching', true);

    // Authenticates User
    __WEBPACK_IMPORTED_MODULE_2__factory__["a" /* default */].authenticate(data).then(function (response) {
      // Sets state.token
      commit('set_token', response.token);

      // State.fetching = false
      // TODO - should this be a global state attribute, perhaps part of a store/main module?
      commit('fetching', false);

      // Shows CREATE_SUCCESS message
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('notification/add', { message: 'Successfully authenticated', context: 'info', dismissible: true });

      // Redirects to REDIRECT_SUCCESS
      // TODO - What is the best way to manage redirection in VueJS?
      window.location = '#/';
    });
  },

  register: function register(_ref2, data) {
    var commit = _ref2.commit;

    // State.fetching = true
    commit('fetching', true);

    // Fetches Collection from the server
    __WEBPACK_IMPORTED_MODULE_2__factory__["a" /* default */].register({ commit: commit }, data).then(function (response) {
      // State.fetching = false
      commit('fetching', false);

      // Shows CREATE_SUCCESS message
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('notification/add', { message: 'Successfully registered new user.', context: 'info', dismissible: true });

      // Redirects to REDIRECT_SUCCESS
      // TODO - What is the best way to manage redirection in VueJS?
      window.location = '#/auth/login';
    }).catch(function (obj) {
      // State.fetching = false
      commit('fetching', false);
      console.log(obj);
      // Shows CREATE_SUCCESS message
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('notification/add', { message: 'Error registering new user.', context: 'danger', dismissible: true });
    });
  },

  logout: function logout(_ref3, data) {
    var commit = _ref3.commit;

    commit('flush_token');
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('notification/add', { message: 'Successfully logged out.', context: 'info', dismissible: true });
    window.location = '#/auth/login';
  },

  is_authenticated: function is_authenticated(_ref4, data) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__factory__["a" /* default */].getSession(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['auth/token']).then(function (session) {
        commit('set_user', session);
      }).catch(function () {
        console.log('Error fetching session');
      });
    });
  },

  // TODO - constantize `authorize` parameters
  googleAuthenticate: function googleAuthenticate(_ref5) {
    var commit = _ref5.commit;

    window.gapi.auth.authorize({
      'client_id': '540231188701-t4pjco404n921r9k347jo2dpp0pgell9.apps.googleusercontent.com',
      'scope': ['https://www.googleapis.com/auth/spreadsheets', 'https://www.googleapis.com/auth/userinfo.email'],
      'immediate': false
    }, function (result) {
      console.log(result);
      if (result.status.signed_in) {
        commit('googleAuthenticated', true);
      } else {
        commit('googleAuthenticated', false);
      }
    });
  },

  // getGoogleUser
  getGoogleUser: function getGoogleUser(_ref6) {
    var commit = _ref6.commit;

    window.gapi.client.load('plus', 'v1', function () {
      window.gapi.client.plus.people.get({
        'userId': 'me'
      }).execute(function (response) {
        if (response) {
          console.info('Got user info');
          console.log(response);
          commit('googleUser', response);
        }
      });
    });
  }

  // // // //

};/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1e0a8e4663052bb6b7a2.js